import admin, { getMenuItems, resultHandler, getStores, clearSelect2Cache, getQuantityForCount, getMenuItemById, hasRole, getMenuCategoryAdmin, getMenuItemAdmin, getMenuItemByGlobalId } from "../admin";
import $ from "jquery";
import moment from "moment";
import { tmplparams } from "../order-list-util";
import auth, { startpoll, isVisible, confirmDialog, executeLongJob, getLocale, parseNumber, isTop, getMenuItemImageUrl, get, ajaxCallStart, ajaxCallEnd, whatDecimalSeparator, getKeyboardFocusableElements, calcCount, choiceDialog2, messageDialog, getInputDialog } from "../auth";
import Cleave from "cleave.js";
import { createTree } from "jquery.fancytree";
import { I18n } from "react-redux-i18n";
import languages from "../../langs/languages";
import menuitemutil from "./menuitem";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs/dist/exceljs.min.js";



const { local, admin_local } = languages;

var inventories = {
	inventories: null,
	templates: []
}
const INVENTORY_EDITABLE_EXCEL_COLUMNS = {
	menuItemId: 'menu_item_id',
	menuItemGlobalId: 'menu_item_global_id',
	category: 'category',
	product: 'product',
	quantity: 'inventory_quantity',
	quantityType: 'quantity_type',
	count: 'count'
};
const INVENTORY_COUNT_COLUMN_KEYS = ['count_1', 'count_2', 'count_3', 'count_4', 'count_5'];

const INVENTORY_EXCEL_HEADER_ALIASES = {
	menuItemId: [
		'menu_item_id', 'menu item id', 'product id', 'termék azonosító', 'termek azonosito', 'id'
	],
	menuItemGlobalId: [
		'menu_item_global_id', 'menu item global id', 'global id', 'termék globális azonosító', 'termek globalis azonosito', 'gid'
	],
	category: ['category', 'kategória', 'kategoria'],
	product: ['product', 'termék', 'termek', 'name', 'név', 'nev'],
	quantity: ['inventory_quantity', 'inventory quantity', 'inventory quantity unit', 'készletezési mennyiség', 'keszletezesi mennyiseg', 'mennyiség', 'mennyiseg'],
	quantityType: ['quantity_type', 'quantity type', 'mértékegység', 'mertekegyseg', 'unit'],
	count: ['count', 'darabszám', 'darabszam', 'count (', 'darabszám (', 'count_1', 'count_2', 'count_3', 'count_4', 'count_5']
};

const normalizeInventoryExcelHeader = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

function getInventoryExcelLabels(storeName) {
	const countBaseLabel = I18n.t('admin_local.inventory_excel_count') || INVENTORY_EDITABLE_EXCEL_COLUMNS.count;
	const countLabelWithStore = storeName ? (countBaseLabel + ' (' + storeName + ')') : countBaseLabel;
	return {
		menuItemId: I18n.t('admin_local.inventory_excel_menu_item_id') || INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId,
		menuItemGlobalId: I18n.t('admin_local.inventory_excel_menu_item_global_id') || INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId,
		category: I18n.t('admin_local.category') || INVENTORY_EDITABLE_EXCEL_COLUMNS.category,
		product: I18n.t('admin_local.product') || INVENTORY_EDITABLE_EXCEL_COLUMNS.product,
		quantity: I18n.t('admin_local.inventory_excel_inventory_quantity') || INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity,
		quantityType: I18n.t('admin_local.quantity_type') || INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType,
		count: countLabelWithStore,
		countBase: countBaseLabel,
		countColumns: Array.from({ length: 5 }, (_, index) => `${countLabelWithStore} ${index + 1}`)
	};
}

function resolveInventoryExcelFieldValue(row, aliases) {
	const normalizedAliases = (aliases || []).map(normalizeInventoryExcelHeader);
	const key = Object.keys(row || {}).find(rowKey => normalizedAliases.indexOf(normalizeInventoryExcelHeader(rowKey)) !== -1);
	return key ? row[key] : undefined;
}
var loaded = false;
export const clearData = () => {
	loaded = false;
	inventories = {
		inventories: null,
		templates: []
	};
	$('body').unbind('keyup', keyupHandler);
}

var numeralDecimalMark = whatDecimalSeparator();

const hasInventoryTemplateAccess = (action) => hasRole("stockmanagement.inventorytemplates." + action);
const canUseInventoryTemplates = () => hasInventoryTemplateAccess("view");

function updateInventoryTemplateModeAccess() {
	const templateModeSelect = $('select#inventoryRecordMode');
	if (!templateModeSelect.length)
		return;
	const canUseTemplates = canUseInventoryTemplates();
	templateModeSelect.prop('disabled', !canUseTemplates);
	templateModeSelect.find('option[value="template"]').toggle(canUseTemplates);
	if (!canUseTemplates) {
		localStorage.inventoryListMode = 'normal';
		templateModeSelect.val('normal');
		templateModeSelect.trigger('change.select2');
		return;
	}
	if ((localStorage.inventoryListMode || 'normal') === 'template') {
		templateModeSelect.val('template');
		templateModeSelect.trigger('change.select2');
	}
}

const JSZip = require('jszip');
const { sortInventoryRowsByMenuOrder, detectInventoryExcelFormat, detectInventoryStoreFromExcelHeaders, isValidInventoryCountInput, getInventoryCountValidationFormula, applyInventoryDataValidationXml } = require('./inventoryExcelOrder');

function buildInventoryEditableExcelRows() {
	const rows = [];
	$('#entriesFreezeTable > table tbody#entriesTable tr.selectable').each((ind, e) => {
		const product = $(e).find('select.product').select2('val');
		if (!product)
			return;
		const menuItem = getMenuItem(product);
		if (!menuItem)
			return;
		const quantityTypeValue = $(e).find('select.quantity_type').select2('val');
		if (!quantityTypeValue)
			return;
		const quantity = Number(quantityTypeValue.split(';')[0]);
		const quantityType = quantityTypeValue.split(';')[1];
		const categoryId = Number(menuItem.menuCategoryId);
		const category = getMenuCategoryAdmin(categoryId);
		const categoryName = category ? (menuitemutil._getPath(category) || getLocale(category.name) || category.name || '') : '';
		const rowObject = {
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId]: Number(menuItem.id),
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId]: Number(menuItem.globalId || 0),
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.category]: categoryName,
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.product]: getLocale(menuItem.name),
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity]: quantity,
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType]: quantityType
		};
		INVENTORY_COUNT_COLUMN_KEYS.forEach(key => {
			rowObject[key] = '';
		});
		rows.push(rowObject);
	});
	return sortInventoryRowsByMenuOrder(rows, getRootMenuNodes());
}

async function exportEditableInventoryToExcel() {
	const rows = buildInventoryEditableExcelRows();
	const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	const modal = $('div#editInventory');
	const storeId = modal.find('select#store').select2('val');
	const store = (inventories.stores || []).find(s => String(s.id) === String(storeId));
	const labels = getInventoryExcelLabels(store && store.name ? store.name : '');
	const countHeaderLabel = labels.count;

	const workbook = new ExcelJS.Workbook();
	const worksheet = workbook.addWorksheet('inventory', {
		views: [{ state: 'frozen', ySplit: 1 }]
	});

	const countColumns = INVENTORY_COUNT_COLUMN_KEYS.map((key, index) => ({
		header: labels.countColumns[index] || `${labels.countBase} ${index + 1}`,
		key,
		width: 18
	}));
	worksheet.columns = [
		{ header: labels.menuItemId, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId, width: 14 },
		{ header: labels.menuItemGlobalId, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId, width: 16 },
		{ header: labels.category, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.category, width: 34 },
		{ header: labels.product, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.product, width: 42 },
		{ header: labels.quantity, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity, width: 16 },
		{ header: labels.quantityType, key: INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType, width: 14 },
		...countColumns
	];

	const fillGuideTitle = I18n.t('admin_local.fill_out_guide') || 'Fill-out guide';
	const fillGuideRows = [
		[fillGuideTitle, '', '', '', '', '', ''],
		[(I18n.t('admin_local.inventory_excel_guide_no_unit') || 'If no unit is written, the value is interpreted as count × quantity × quantity_type. Example: quantity=1000, quantity_type=g, count=2 means 2 × 1000g = 2000g.').replace('{0}', labels.quantity).replace('{1}', labels.quantityType), '', '', '', '', '', ''],
		[(I18n.t('admin_local.inventory_excel_guide_editable_column') || 'Only the "{0}" column is editable.').replace('{0}', countHeaderLabel), '', '', '', '', '', ''],
		[I18n.t('admin_local.inventory_excel_guide_units') || 'You can enter values like 10l, 10dl, 10g, 10kg, 10pcs. The system converts them automatically.', '', '', '', '', '', ''],
		[I18n.t('admin_local.inventory_excel_guide_empty_skipped') || 'If count is empty, the row is skipped during import.', '', '', '', '', '', ''],
		['', '', '', '', '', '', '']
	];

	const border = {
		top: { style: 'thin', color: { argb: 'FF9AA5B1' } },
		bottom: { style: 'thin', color: { argb: 'FF9AA5B1' } },
		left: { style: 'thin', color: { argb: 'FF9AA5B1' } },
		right: { style: 'thin', color: { argb: 'FF9AA5B1' } }
	};

	const headerRow = worksheet.getRow(1);
	headerRow.eachCell((cell) => {
		cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
		cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1D3557' } };
		cell.alignment = { horizontal: 'center', vertical: 'middle' };
		cell.border = border;
		cell.protection = { locked: true };
	});
	headerRow.height = 22;
	worksheet.views = [{ state: 'frozen', ySplit: 1 }];

	let previousCategory = null;
	rows.forEach(row => {
		const currentCategory = row[INVENTORY_EDITABLE_EXCEL_COLUMNS.category] || '';
		if (currentCategory !== previousCategory) {
			const categoryRow = worksheet.addRow({
				[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId]: currentCategory || I18n.t('admin_local.other')
			});
			worksheet.mergeCells(categoryRow.number, 1, categoryRow.number, 7);
			categoryRow.eachCell((cell) => {
				cell.font = { bold: true, color: { argb: 'FF1D3557' } };
				cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDCEAF7' } };
				cell.alignment = { horizontal: 'left', vertical: 'middle' };
				cell.border = border;
				cell.protection = { locked: true };
			});
			previousCategory = currentCategory;
		}

		const rowValueMap = {
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId],
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId],
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.category]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.category],
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.product]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.product],
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity],
			[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType]: row[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType]
		};
		INVENTORY_COUNT_COLUMN_KEYS.forEach(key => {
			rowValueMap[key] = row[key] || '';
		});
		const dataRow = worksheet.addRow(rowValueMap);

		dataRow.eachCell((cell, colNumber) => {
			cell.border = border;
			if (colNumber >= 7) {
				cell.alignment = { horizontal: 'right', vertical: 'middle' };
				cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF4CC' } };
				cell.protection = { locked: false };
				worksheet.dataValidations.add(cell.address, {
					type: 'custom',
					showErrorMessage: true,
					errorStyle: 'stop',
					errorTitle: I18n.t('local.error_message') || 'Error',
					error: I18n.t('admin_local.invalid_inventory_count') || 'Use a number or a number with the matching unit for this item.',
					allowBlank: true,
					formula1: getInventoryCountValidationFormula(row[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType] || '', cell.address)
				});
			} else {
				cell.alignment = { horizontal: colNumber === 3 || colNumber === 4 ? 'left' : 'center', vertical: 'middle' };
				cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8FBFF' } };
				cell.protection = { locked: true };
			}
		});
	});

	const guideStartRow = worksheet.rowCount + 2;
	fillGuideRows.forEach((rowValues, index) => {
		const rowNumber = guideStartRow + index;
		const row = worksheet.getRow(rowNumber);
		row.values = rowValues;
		worksheet.mergeCells(rowNumber, 1, rowNumber, 7);
		const cell = row.getCell(1);
		cell.border = border;
		cell.protection = { locked: true };
		if (index === 0) {
			cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
			cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2A9D8F' } };
			cell.alignment = { horizontal: 'left', vertical: 'middle' };
			row.height = 22;
		} else {
			cell.font = { color: { argb: 'FF2F3E46' } };
			cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFF7F6' } };
			cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
			row.height = 20;
		}
	});

	worksheet.autoFilter = {
		from: { row: 1, column: 1 },
		to: { row: 1, column: 7 }
	};

	await worksheet.protect('', {
		selectLockedCells: true,
		selectUnlockedCells: true,
		formatCells: false,
		formatColumns: false,
		formatRows: false,
		insertColumns: false,
		insertRows: false,
		insertHyperlinks: false,
		deleteColumns: false,
		deleteRows: false,
		sort: true,
		autoFilter: true,
		pivotTables: false,
		objects: false,
		scenarios: false
	});

	const excelBuffer = await workbook.xlsx.writeBuffer();
	const zip = await JSZip.loadAsync(excelBuffer);
	await Promise.all(workbook.worksheets.map(async (sheet, index) => {
		const fileName = `xl/worksheets/sheet${index + 1}.xml`;
		const sheetFile = zip.file(fileName);
		if (!sheetFile)
			return;
		const xml = await sheetFile.async('string');
		const patchedXml = applyInventoryDataValidationXml(xml, sheet.dataValidations && sheet.dataValidations.model ? sheet.dataValidations.model : {});
		zip.file(fileName, patchedXml);
	}));
	const patchedBuffer = await zip.generateAsync({ type: 'nodebuffer' });
	const data = new Blob([patchedBuffer], { type: fileType });
	const dateLabel = modal.find('input#date').val() || moment().format('YYYY-MM-DD');
	const fileName = (auth.myStatus.restaurant_name || 'inventory') + '_' + (store ? store.name : 'store') + '_' + dateLabel + '.xlsx';
	saveAs(data, fileName);
}

function importEditableInventoryRowsForSelectedInventory(file) {
	const selectedInventory = {
		id: null,
		date: new Date(),
		draft: false,
		template: false,
		templateName: '',
		store: null,
		entries: []
	};
	const labels = getInventoryExcelLabels('');
	const reader = new FileReader();
	reader.addEventListener('load', () => {
		try {
			const workbook = window.XLSX.read(reader.result, { type: 'binary' });
			const firstSheet = workbook.SheetNames && workbook.SheetNames.length ? workbook.SheetNames[0] : null;
			if (!firstSheet)
				return;
			const rowObject = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
			const continueImport = (stores) => {
				const inferredStore = detectInventoryStoreFromExcelHeaders(rowObject, stores || []);
				if (inferredStore && (!selectedInventory.store || !selectedInventory.store.id)) {
					selectedInventory.store = { id: inferredStore.id, name: inferredStore.name };
				}
				const importedEntries = [];
				const notFoundMenuItems = [];
				let queue = 1;
				const headerAliases = {
					menuItemId: [...new Set([...(INVENTORY_EXCEL_HEADER_ALIASES.menuItemId || []), INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId, 'id', labels.menuItemId, I18n.t('admin_local.id') || 'id'])],
					menuItemGlobalId: [...new Set([...(INVENTORY_EXCEL_HEADER_ALIASES.menuItemGlobalId || []), INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId, 'gid', labels.menuItemGlobalId, 'global id'])],
					quantity: [...new Set([...(INVENTORY_EXCEL_HEADER_ALIASES.quantity || []), INVENTORY_EDITABLE_EXCEL_COLUMNS.quantity, 'quantity', 'inventory quantity unit', labels.quantity])],
					count: [...new Set([...(INVENTORY_EXCEL_HEADER_ALIASES.count || []), INVENTORY_EDITABLE_EXCEL_COLUMNS.count, labels.countBase])]
				};
				const resolveCountValue = (row) => {
					const keys = Object.keys(row || {});
					const countKey = keys.find(key => normalizeInventoryExcelHeader(key) === normalizeInventoryExcelHeader(INVENTORY_EDITABLE_EXCEL_COLUMNS.count))
						|| keys.find(key => normalizeInventoryExcelHeader(key) === normalizeInventoryExcelHeader(labels.countBase))
						|| keys.find(key => normalizeInventoryExcelHeader(key).startsWith(normalizeInventoryExcelHeader(INVENTORY_EDITABLE_EXCEL_COLUMNS.count + ' (')))
						|| keys.find(key => normalizeInventoryExcelHeader(key).startsWith(normalizeInventoryExcelHeader(labels.countBase + ' (')))
						|| keys.find(key => /(?:^|_)(count|darabszam)[_ -]?[0-9]+$/.test(normalizeInventoryExcelHeader(key)))
						|| keys.find(key => /(?:^| )(count|darabszam) \([^)]+\)[ _-]?[0-9]+$/.test(normalizeInventoryExcelHeader(key)));
					if (!countKey)
						return resolveInventoryExcelFieldValue(row, headerAliases.count);
					return row[countKey];
				};
				const resolveConsolidatedCountValue = (row) => {
					const numberedCountValues = INVENTORY_COUNT_COLUMN_KEYS.map(key => row[key] ?? resolveInventoryExcelFieldValue(row, [key]))
						.filter(value => value !== undefined && value !== null && String(value).trim() !== '');
					if (numberedCountValues.length) {
						return numberedCountValues.length === 1 ? numberedCountValues[0] : numberedCountValues;
					}
					const legacyValues = Object.keys(row || {}).filter(key => {
						const normalized = normalizeInventoryExcelHeader(key);
						return normalized === normalizeInventoryExcelHeader(labels.countBase)
							|| normalized.startsWith(normalizeInventoryExcelHeader(labels.countBase + ' ('))
							|| normalized.startsWith(normalizeInventoryExcelHeader(INVENTORY_EDITABLE_EXCEL_COLUMNS.count + ' ('));
					}).map(key => row[key]).filter(value => value !== undefined && value !== null && String(value).trim() !== '');
					if (legacyValues.length)
						return legacyValues.length === 1 ? legacyValues[0] : legacyValues;
					return resolveCountValue(row);
				};

				const finalize = () => {
					queue--;
					if (queue > 0)
						return;
					if (notFoundMenuItems.length) {
						messageDialog(I18n.t('admin_local.the_following_products_were_not_found'), notFoundMenuItems.join('<br>'));
					}
					if (!importedEntries.length) {
						messageDialog(I18n.t('local.error_message'), I18n.t('admin_local.no_entries_can_be_added_for_selected_store'));
						return;
					}
					inventories.uploadeddata = {
						...selectedInventory,
						entries: importedEntries
					};
					$('#edit').prop('disabled', false);
					$('#edit').trigger('click');
					$('#edit').prop('disabled', true);
				};

				rowObject.forEach(row => {
					const menuItemId = Number(resolveInventoryExcelFieldValue(row, headerAliases.menuItemId) || 0);
					const globalId = Number(resolveInventoryExcelFieldValue(row, headerAliases.menuItemGlobalId) || 0);
					if (!menuItemId && !globalId)
						return;
					const rawCountValue = resolveConsolidatedCountValue(row);
					if (rawCountValue === undefined || rawCountValue === null || String(rawCountValue).trim() === '')
						return;
					const quantity = Number(resolveInventoryExcelFieldValue(row, headerAliases.quantity) || 0);
					if (!quantity)
						return;
					queue++;
					getMenuItem(menuItemId, globalId, menuItem => {
						if (!menuItem || menuItem.type === 'deleted' || menuItem.recordState === 'DELETED' || menuItem.isActive === false || menuItem.active === false) {
							notFoundMenuItems.push((row[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemId] || row[INVENTORY_EDITABLE_EXCEL_COLUMNS.menuItemGlobalId] || '') + ' ' + (row[INVENTORY_EDITABLE_EXCEL_COLUMNS.product] || ''));
							finalize();
							return;
						}
						const available = (menuItem.availableQuantities || []).some(q => q && q.inventoryItem && Number(q.quantity) === quantity);
						if (!available) {
							finalize();
							return;
						}
						const countParts = Array.isArray(rawCountValue) ? rawCountValue : String(rawCountValue).split('+').map(part => part.trim()).filter(part => part !== '');
						if (!countParts.length || !countParts.every(part => isValidInventoryCountInput(part, menuItem.quantityType || row[INVENTORY_EDITABLE_EXCEL_COLUMNS.quantityType] || ''))) {
							finalize();
							return;
						}
						const consolidatedCount = countParts.reduce((sum, part) => {
							const converted = calcCount(part, menuItem.quantityType, quantity);
							const parsed = parseNumber(String(converted));
							if (parsed === undefined || parsed === null || parsed === '' || isNaN(parsed))
								return sum;
							return sum + Number(parsed);
						}, 0);
						if (countParts.length && (isNaN(consolidatedCount) || !Number.isFinite(consolidatedCount))) {
							finalize();
							return;
						}
						importedEntries.push({
							menuItem: { id: menuItem.id, type: menuItem.entityType.toLowerCase() },
							quantityType: menuItem.quantityType,
							quantity: quantity,
							count: consolidatedCount
						});
						finalize();
					});
				});
				finalize();
			};
			if (Array.isArray(inventories.stores) && inventories.stores.length) {
				continueImport(inventories.stores);
			} else {
				admin.getStores(stores => {
					inventories.stores = stores;
					continueImport(stores);
				});
			}
		} catch (ex) {
			console.log(ex);
		}
	});

	reader.readAsBinaryString(file);
}

export const ready = () => {
	loaded = true;
	clearSelect2Cache();
	menuitemutil.entityType = undefined;
	menuitemutil.entitytype = undefined;

	const def = $.Deferred();
	getMenuItems(function (data) {
		admin.categories = data;

		$('#inventoriesTemplate').tmpl(tmplparams()).appendTo("#main");

		$('#editInventory').keyup(keyupHandler);

		$("#excel, #exportInventoryFooter").click(() => {
			exportEditableInventoryToExcel();
		})

		inventories.categories = data;
		$('#date.datepicker').datepicker({
			format: 'yyyy-mm-dd',
			uiLibrary: 'bootstrap4',
			enableOnReadonly: false
		});
		$('#time.timepicker').timepicker({
			format: 'HH:MM',
			uiLibrary: 'bootstrap4',
			enableOnReadonly: false
		});
		if (waiterAccessOnly()) {
			$('#date.datepicker + .input-group-append').remove();
			$('#time.timepicker + .input-group-append').remove();
		}


		if (viewStock()) {
			var i = $('#entriesFreezeTable > table tfoot input#value-difference').get(0);
			$(i).data('cleave', new Cleave(i, {
				numeral: true,
				numeralThousandsGroupStyle: 'thousand',
				numeralPositiveOnly: false,
				numeralDecimalScale: 3,
				delimiter: ' ',
				numeralDecimalMark: numeralDecimalMark,
			}));
		}

		getStores(data => {
			inventories.stores = data
			admin.initializeSelect2($('select.select2[entity]')).done(() => {
				$('select#inventoryRecordMode').select2({
					minimumResultsForSearch: Infinity,
					width: '100%'
				});
				if (!localStorage.inventoryListMode)
					localStorage.inventoryListMode = 'normal';
				updateInventoryTemplateModeAccess();
				$('select#inventoryRecordMode').val(localStorage.inventoryListMode);
				$('select#inventoryRecordMode').trigger('change.select2');
				updateInventoryPageModeState();
				$('select#inventoryRecordMode').off('change.inventoryMode').on('change.inventoryMode', function () {
					if ($(this).val() === 'template' && !canUseInventoryTemplates()) {
						$(this).val('normal');
						localStorage.inventoryListMode = 'normal';
					}
					localStorage.inventoryListMode = $(this).val() || 'normal';
					updateInventoryPageModeState();
					$('#upload').toggle(!isTemplateMode());
					loadInventories();
				});
				loadInventories();

				startpoll(serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);



				updateHooks();

				$("select#product_filter.select2").change(function (e) {
					reload();
				});

				if (waiterAccessOnly())
					$('#editInventory #store.select2').change(e => {
						const count = $('div#editInventory #entriesFreezeTable > table tbody tr.selectable').length;
						if (count === 0)
							populateAllItems();
					});

				def.resolve();
			});
		});
	}, undefined, false, true);
	return def.promise();

}

function keyupHandler(e) {
	switch (e.key) {
		case '+':
			if (isVisible($('#editInventory.modal')))
				addNewEntry();
			break;
		case 'ArrowDown':
			if (isVisible($('#editInventory'))) {
				var column = $("#entriesFreezeTable > table#entriesTable").find(':focus')
				var tr = column.parents('tr');
				var td = column.parents('td');
				if (tr.length === 1) {
					var tds = tr.find('td');
					var index = tds.toArray().indexOf(td[0]) + 1;
					tr = $(tr).next();
					td = tr.find('td:nth-child(' + index + ')');
					td.find('input').focus();
					td.find('input.input-numeral').select();
					td.find('select.select2').select2('focus');
				}
				e.preventDefault();
				e.stopPropagation();
			} else {
			}
			break;
		case 'ArrowUp':
			if (isVisible($('#editInventory'))) {
				column = $("#entriesFreezeTable > table#entriesTable").find(':focus')
				tr = column.parents('tr');
				td = column.parents('td');
				if (tr.length === 1) {
					tds = tr.find('td');
					index = tds.toArray().indexOf(td[0]) + 1;
					tr = $(tr).prev();
					td = tr.find('td:nth-child(' + index + ')');
					td.find('input').focus();
					td.find('input.input-numeral').select();
					td.find('select.select2').select2('focus');
				}
				e.preventDefault();
				e.stopPropagation();
			} else {
			}
			break;
		case 'Insert':
			if (e.ctrlKey) {
				if (isVisible($('#editInventory'))) {
					addNewEntry();
					e.preventDefault();
					e.stopPropagation();
				} else {
					$('button#add').click();
				}
			}
			break;
		case 'Delete':
			if (e.ctrlKey) {
				if (isVisible($('#editInventory'))) {
					var data = $("#entriesFreezeTable > table#entriesTable").find(':focus');
					e.currentTarget = data;
					deleteEntry(e);
				} else {
					$('button#delete').click();
				}
				e.preventDefault();
				e.stopPropagation();
			}
			break;
		case 'Enter':
			if (!isTop($('#editInventory'))) {
				$('button#edit').click();
				e.preventDefault();
			}
			break;
		default:
	}
}

export const reload = () => {
	loadInventories();
}

function emptyIfNull(val) {
	if (val === null)
		return "";
	return val;
}

function isTemplateMode() {
	if (!canUseInventoryTemplates())
		return false;
	return (localStorage.inventoryListMode || 'normal') === 'template';
}

function updateInventoryPageModeState(forceTemplateMode) {
	const templateMode = typeof forceTemplateMode === 'boolean' ? forceTemplateMode : isTemplateMode();
	$('body').toggleClass('inventory-mode-template', templateMode);
	$('body').toggleClass('inventory-mode-normal', !templateMode);
	$('#upload').toggle(!templateMode);
	$('#exportInventoryFooter').toggle(!templateMode);
}

function updateInventoryColumnsForTemplate(isTemplateRecord) {
	const table = $('#editInventory #entriesFreezeTable > table#entriesTable');
	const showNormalColumns = !isTemplateRecord && !isTemplateMode();
	// jQuery toggle(true) would leave an inline display:block on the table cells and break the table layout.
	table.find('.inventory-stock-column, .inventory-value-diff-column').css('display', showNormalColumns ? '' : 'none');
	$('body').toggleClass('inventory-mode-template', isTemplateRecord || isTemplateMode());
	$('body').toggleClass('inventory-mode-normal', !(isTemplateRecord || isTemplateMode()));
}

function loadInventoryTemplates(handler) {
	const filter = {
		menuitem: "",
		template: true,
		draft: false
	};
	admin.getEntitiesFiltered("Inventorie", filter, data => {
		inventories.templates = Array.isArray(data) ? data.filter(templateInventory => !templateInventory.draft) : [];
		if (handler)
			handler(inventories.templates);
	});
}

function updateTemplateSourceOptions() {
	const select = $('#editInventory #inventoryTemplateSource');
	if (!select.length)
		return;
	select.empty();
	select.append('<option value="">' + (admin_local.select ? admin_local.select : 'Select') + '</option>');
	(inventories.templates || []).forEach(templateInventory => {
		const store = templateInventory.store ? getStore(templateInventory.store.id) : null;
		const storeName = store ? store.name : '';
		const titleParts = [templateInventory.templateName || moment(templateInventory.date).format('YYYY-MM-DD HH:mm')];
		if (storeName)
			titleParts.push(storeName);
		const optionLabel = titleParts.join(' - ');
		const displayLabel = templateInventory.masterTemplate ? optionLabel + ' (master)' : optionLabel;
		const option = $('<option value="' + templateInventory.id + '"' + (templateInventory.masterTemplate ? ' data-master-template="true"' : ' data-local-template="true"') + '>' + displayLabel + '</option>');
		if (templateInventory.masterTemplate) {
			option.css({
				'background-color': '#fff3d6',
				'color': '#5a3c00'
			});
		} else {
			option.css({
				'background-color': '#eaf3ff',
				'color': '#1f3f73'
			});
		}
		select.append(option);
	});
	select.select2({
		allowClear: true,
		placeholder: select.data('placeholder') || (admin_local.select ? admin_local.select : 'Select'),
		minimumResultsForSearch: 'Infinity',
		width: 'resolve',
		theme: 'default fullScreenSelect',
		templateResult: state => {
			if (!state.id)
				return state.text;
			const $state = $('<span></span>').text(state.text);
			const isMaster = $(state.element).data('master-template');
			const isLocal = $(state.element).data('local-template');
			if (isMaster) {
				$state.css({
					'display': 'inline-block',
					'width': '100%',
					'padding': '2px 6px',
					'border-radius': '4px',
					'background-color': '#fff3d6',
					'color': '#5a3c00'
				});
			} else if (isLocal) {
				$state.css({
					'display': 'inline-block',
					'width': '100%',
					'padding': '2px 6px',
					'border-radius': '4px',
					'background-color': '#eaf3ff',
					'color': '#1f3f73'
				});
			}
			return $state;
		},
		templateSelection: state => {
			if (!state.id)
				return state.text;
			const $state = $('<span></span>').text(state.text);
			const isMaster = $(state.element).data('master-template');
			const isLocal = $(state.element).data('local-template');
			if (isMaster) {
				$state.css({
					'display': 'inline-block',
					'padding': '0 6px',
					'border-radius': '4px',
					'background-color': '#fff3d6',
					'color': '#5a3c00'
				});
			} else if (isLocal) {
				$state.css({
					'display': 'inline-block',
					'padding': '0 6px',
					'border-radius': '4px',
					'background-color': '#eaf3ff',
					'color': '#1f3f73'
				});
			}
			return $state;
		}
	});
}

function isTemplateEntryAvailable(entryData, isMasterTemplate = false) {
	if (!entryData || !entryData.menuItem)
		return false;
	const menuItemId = Number(entryData.menuItem.id || entryData.menuItemId || 0);
	const menuItem = _getMenuItem(isMasterTemplate ? null : menuItemId, isMasterTemplate ? menuItemId : null, inventories.categories && inventories.categories.activeMenuCategories ? inventories.categories.activeMenuCategories : (inventories.categories && inventories.categories.children ? inventories.categories.children : []));
	if (!menuItem || menuItem.type === 'deleted' || menuItem.recordState === 'DELETED')
		return false;
	entryData.menuItem.id = menuItem.id;
	entryData.menuItem.menuCategoryId = menuItem.menuCategoryId;
	if (menuItem.isActive === false || menuItem.active === false)
		return false;
	if (menuItem.defaultInventoryItem === false || menuItem.inventoryItem === false)
		return false;
	if (Array.isArray(menuItem.availableQuantities) && menuItem.availableQuantities.length > 0) {
		return menuItem.availableQuantities.some(quantity => quantity && quantity.inventoryItem === true && quantity.onMenu !== false);
	}
	return true;
}

function applyTemplateToModal(templateId) {
	const selectedId = Number(templateId);
	if (!selectedId)
		return;
	const templateInventory = (inventories.templates || []).find(i => i.id === selectedId);
	if (!templateInventory)
		return;
	const modal = $('div#editInventory');
	modal.find('#entriesFreezeTable > table#entriesTable tbody tr').remove();
	if (templateInventory.store) {
		modal.find('select#store').val(templateInventory.store.id);
		modal.find('select#store').trigger('change');
	}
	(templateInventory.entries || []).filter(entryData => isTemplateEntryAvailable(entryData, templateInventory.masterTemplate)).forEach(entryData => {
		const normalizedEntryData = {
			...entryData,
			count: 0,
			originalCount: 0,
			valueDifference: 0,
			ocount: 0,
			ovaluediff: 0
		};
		const entryRow = addNewEntry(normalizedEntryData, false);
		const row = $(entryRow);
		row.find('input.count').val(0);
		row.find('input.ovaluediff').each((_, el) => {
			const field = $(el);
			if (field.data('cleave'))
				field.data('cleave').setRawValue(0);
			else
				field.val(0);
		});

		const menuItemId = row.find('select.product').val();
		const quantity = row.find('select.quantity_type').val() ? row.find('select.quantity_type').val().split(';')[0] : 0;
		const dateString = modal.find('input#date').val() + ' ' + modal.find('input#time').val();
		const date = moment(dateString, 'YYYY-MM-DD HH-mm').toDate().getTime();
		const store = modal.find('select#store').select2('val');
		const expiryValue = row.find('input.expiry').val();
		const expiry = expiryValue ? new Date(expiryValue).getTime() : '';
		if (menuItemId && quantity && store) {
			admin.getCostAndPriceHistoryAt(menuItemId, quantity, store, expiry, date, data => {
				if (row.find('input.ocount').data('cleave')) {
					row.find('input.ocount').data('cleave').setRawValue(Number(data.count || 0));
				} else {
					row.find('input.ocount').val(Number(data.count || 0));
				}
				updateStockCount(row, Number(data.count || 0));
			}, () => {
				if (row.find('input.ocount').data('cleave')) {
					row.find('input.ocount').data('cleave').setRawValue(0);
				} else {
					row.find('input.ocount').val(0);
				}
				updateStockCount(row, 0);
			});
		}
	});
	rebuildEntryGroups();
}

function loadInventories() {
	if (!loaded)
		return;
	var filter = {
		menuitem: emptyIfNull($('select#product_filter').select2('val')),
		template: isTemplateMode()
	};
	if (!isTemplateMode()) {
		filter.from = localStorage.admin_stocklist_start;
		filter.to = localStorage.admin_stocklist_end;
	}
	admin.getEntitiesFiltered("Inventorie", filter, processInventories);
}

function serverSideMessageHandler(data) {
}


function processInventories(data) {
	data.forEach(function (v, i) {
		v.title = v.template && v.templateName ? v.templateName : moment(v.date).format('YYYY-MM-DD HH:mm');
		v.folder = false;
		v.key = v.id;
	});
	if (!(inventories.inventories))
		inventories.inventories = createTree("#listFreezeTable > table#listTable", {
			checkbox: false,
			titlesTabbable: true, // Add all node titles to TAB chain
			source: data,
			zindex: 1000,
			icon: false,
			keyboard: true,
			extensions: ["table", "gridnav", "persist"],
			clickNodeToDeselect: true,
			table: {
				checkboxColumnIdx: 0, // render the checkboxes into the this
				indentation: 16, // indent every node level by 16px
				nodeColumnIdx: 0
				// render node expander, icon, and title to this column (default:
				// #0)
			},
			persist: {
				cookiePrefix: 'fancytree-1-Inventory',
				expandLazy: false,
				overrideSource: false, // true: cookie takes precedence
				// over `source` data
				// attributes.
				store: "auto" // 'cookie', 'local': use localStore,
				// 'session': sessionStore
			},
			gridnav: {
				autofocusInput: true, // Focus first embedded input if node
				// gets activated
				handleCursorKeys: true
				// Allow UP/DOWN in inputs to move to prev/next node
			},
			activate: function (event, data) {
				// A node was activated: display its title:
				var node = data.node;
				$('#edit').removeAttr('disabled');
				$('#delete').removeAttr('disabled');
				if (node.data.isActive) {
					$('#deactivate').removeAttr('disabled');
					$('#activate').prop('disabled', 'true');
				} else {
					$('#deactivate').prop('disabled', 'true');
					$('#activate').removeAttr('disabled');
				}

			},
			click: (event, data) => {
				if (inventories.clickTimestamp && inventories.selectedNodeKey === data.node.key && new Date().getTime() - inventories.clickTimestamp < 500) {
					$('button#edit').click();
				} else {
					if (data.node === inventories.inventories.previousNode && !$(event.toElement).hasClass("fancytree-expander")) {
						inventories.inventories.activateKey("");
						event.preventDefault();
						inventories.inventories.previousNode = null;
					} else {
						inventories.inventories.previousNode = data.node;
					}

				}
				inventories.clickTimestamp = new Date().getTime();
				inventories.selectedNodeKey = data.node.key;
			},
			/*
			dblclick: function (event, data) {
				$('button#edit').click();
			},
			*/
			renderColumns: function (event, data) {
				var node = data.node, $tdList = $(node.tr).find(">td");

				node.expanded = true;

				var c = 1;

				$tdList.eq(c++).find("input").prop('checked', node.data.draft);
				$tdList.eq(c++).text(getStore(node.data.store.id).name);

				if (node.data.template) {
					const entryLabels = [];
					node.data.entries.forEach(entry => {
						getMenuItem(entry.menuItem.id, null, menuItem => {
							if (!menuItem)
								return;
							const label = (menuItem.manufacturer ? menuItem.manufacturer + " / " : "") + getLocale(menuItem.name);
							entryLabels.push(label + (entry.quantity ? " " + entry.quantity : ""));
							$tdList.eq(8).html(entryLabels.join("<br>"));
						});
					});
					$tdList.eq(3).html("<div style='text-align:right'>" + node.data.entries.length + "</div>");
					$tdList.eq(4).html("");
					$tdList.eq(5).html("");
					$tdList.eq(6).html("");
					$tdList.eq(7).html("");
					$tdList.eq(9).html("");
					return;
				}

				var entries1 = "";
				var entries2 = "";
				var entries3 = "";
				var entries4 = "";
				var entries5 = "";
				var less = 0;
				var more = 0;
				var diff = 0;

				const _waiterAccessOnly = !viewStock();

				node.data.entries.forEach((e, ind) => {
					getMenuItem(e.menuItem.id, null, menuItem => {
						if (menuItem.availableQuantities)
							menuItem.availableQuantities.forEach((quantity) => {

								var qt = getLocale(quantity.quantityType.name);
								if (!qt) {
									qt = local[menuItem.quantityType];
								}

								var clazz = ""
								if (quantity.quantity === e.quantity) {
									if (e.count - e.originalCount < 0 && !_waiterAccessOnly) {
										clazz = "negative";
										less++;
									} else if (e.count - e.originalCount > 0 && !_waiterAccessOnly) {
										clazz = "positive";
										more++;
									}
									entries1 += '<div class="' + clazz + '">' + Math.round(e.originalCount * 1000) / 1000 + "</div>";
									const change = Math.round((((e.count - e.originalCount) > 0 ? "+" : "") + (e.count - e.originalCount)) * 1000) / 1000;
									entries2 += '<div class="' + clazz + '">' + change + "</div>";
									entries3 += '<div class="' + clazz + '">' + Math.round(e.count * 1000) / 1000 + "</div>";
									entries4 += '<div class="' + clazz + '">' + Math.round((e.count - e.originalCount) * menuItem.cost * 1000 * menuitemutil.getInventoryQuantity(menuItem, e.quantity)) / 1000 + "</div>";
									entries5 += '<div class="' + clazz + '">' + (menuItem.manufacturer ? menuItem.manufacturer + " / " : "") + getLocale(menuItem.name) + " " + e.quantity + " " + I18n.t("local." + menuItem.quantityType) + " " + qt + "</div>";
									diff += (e.count - e.originalCount) * menuItem.cost * menuitemutil.getInventoryQuantity(menuItem, e.quantity);
								}
							});
						else {
							entries5 += '<div class="">' + getLocale(menuItem.name) + "</div>";
						}
						$tdList.eq(8).html(entries5);
					});
				})

				var l = "<div style='text-align:right'>" + node.data.entries.length + "</div>";
				if (!_waiterAccessOnly) {
					if (less)
						l += "<div style='text-align:right' class='negative'>" + I18n.t('admin_local.shortage') + ": " + less + "</div>";
					if (more)
						l += "<div style='text-align:right' class='positive'>" + I18n.t('admin_local.surplus') + ": " + more + "</div>";
					if (diff > 0)
						l += "<div style='text-align:right' class='positive'>" + I18n.t('admin_local.value_difference') + ": " + Math.round(diff * 1000) / 1000 + "</div>";
					else if (diff < 0)
						l += "<div style='text-align:right' class='negative'>" + I18n.t('admin_local.value_difference') + ": " + Math.round(diff * 1000) / 1000 + "</div>";
				}
				$tdList.eq(c++).html(l);
				if (node.data.entries.length > 2) {
					entries1 += '<div class="total">&nbsp;...</div>';
					entries2 += '<div class="total">&nbsp;...</div>';
					entries3 += '<div class="total">&nbsp;...</div>';
					entries4 += '<div class="total">&nbsp;...</div>';
					entries5 += '<div class="total">&nbsp;...</div>';
				}
				$tdList.eq(c++).html(entries1);
				if (!_waiterAccessOnly) {
					$tdList.eq(c++).html(entries2);
					$tdList.eq(c++).html(entries3);
					$tdList.eq(c++).html(entries4);
				}
				$tdList.eq(c++).html(entries5);

				var other = "";
				if (node.data.createdBy) {
					var t = moment(node.data.created).format('YYYY-MM-DD   HH:mm');
					other += "<div>" + t + " - " + node.data.createdBy.name + " - " + I18n.t("admin_local.created_by") + "</div>";
				}
				if (node.data.modifiedBy) {
					t = moment(node.data.modified).format('YYYY-MM-DD   HH:mm');
					other += "<div>" + t + " - " + node.data.modifiedBy.name + " - " + I18n.t("admin_local.modified_by") + "</div>";
				}
				$tdList.eq(c++).html(other);


			}

		});
	else {
		inventories.inventories.reload(data);
		var node = inventories.inventories.getActiveNode();
		$('#edit').prop('disabled', node === null);
		$('#delete').prop('disabled', node === null);
	}
}

var tt = null;
var pattern = null;
var saveDraft = null;
var draftId = null;
const INVENTORY_DND_MIN_WIDTH = 801;

function isInventoryDndEnabled() {
	return $(window).width() >= INVENTORY_DND_MIN_WIDTH;
}

function normalizeEntryFilterText(text) {
	return (text || "").toString().toLowerCase().trim();
}

function escapeHtml(text) {
	return $('<div/>').text(text || '').html();
}

function updateEntryGroupFilterOptions(groups) {
	const modal = $('div#editInventory');
	const select = modal.find('select#entryGroupFilter');
	if (!select.length)
		return;

	const selected = select.val() || '';
	const allText = admin_local.all ? admin_local.all : 'All';
	let options = '<option value="">' + escapeHtml(allText) + '</option>';

	(groups || []).forEach(group => {
		if (!group || !group.key)
			return;
		options += '<option value="' + escapeHtml(group.key) + '">' + escapeHtml(group.name) + '</option>';
	});

	select.html(options);
	if (selected && select.find('option[value="' + selected + '"]').length)
		select.val(selected);
	else
		select.val('');
}

function getSelectValueSafe(select) {
	if (!select || !select.length)
		return null;

	if (select.hasClass('select2-hidden-accessible') && select.data('select2'))
		return select.select2('val');

	return select.val();
}

function getEntryFilterableName(entryRow) {
	const row = $(entryRow);
	const productId = getSelectValueSafe(row.find('select.product'));
	if (!productId)
		return "";
	const menuItem = getMenuItem(productId);
	if (!menuItem)
		return "";
	const name = getLocale(menuItem.name) || "";
	const manufacturer = menuItem.manufacturer || "";
	return (manufacturer ? manufacturer + " / " : "") + name;
}

function getEntryGroupInfo(entryRow) {
	const row = $(entryRow);
	const productId = getSelectValueSafe(row.find('select.product'));
	if (!productId)
		return { key: 'uncategorized', name: I18n.t('admin_local.other') === 'admin_local.other' ? 'Other' : I18n.t('admin_local.other') };

	const menuItem = getMenuItem(productId);
	if (!menuItem)
		return { key: 'uncategorized', name: I18n.t('admin_local.other') === 'admin_local.other' ? 'Other' : I18n.t('admin_local.other') };

	const categoryId = Number(menuItem.menuCategoryId);
	const category = getMenuCategoryAdmin(categoryId);
	const categoryName = category ? (menuitemutil._getPath(category) || getLocale(category.name) || category.name || '') : '';
	return {
		key: categoryId > 0 ? ('category-' + categoryId) : 'uncategorized',
		name: categoryName || (I18n.t('admin_local.other') === 'admin_local.other' ? 'Other' : I18n.t('admin_local.other'))
	};
}

function collectGroupBlockRows(tbody, groupKey) {
	const header = tbody.find('tr.entry-group-row[data-group-key="' + groupKey + '"]').first();
	if (!header.length)
		return $();

	const rows = [header.get(0)];
	let next = header.next();
	while (next.length && !next.hasClass('entry-group-row')) {
		rows.push(next.get(0));
		next = next.next();
	}

	return $(rows);
}

function initGroupReorder() {
	const tbody = $('#entriesFreezeTable > table tbody#entriesTable');
	if (!tbody.length)
		return;

	tbody.off('.entryGroupReorder');
	tbody.find('tr.entry-group-row').removeAttr('draggable');

	if (!isInventoryDndEnabled())
		return;

	tbody.find('tr.entry-group-row').attr('draggable', true);

	tbody.on('mousedown.entryGroupReorder touchstart.entryGroupReorder', '.entry-group-drag-handle', function () {
		const header = $(this).closest('tr.entry-group-row');
		tbody.data('dragGroupHandle', header.data('groupKey'));
	});

	tbody.on('dragstart.entryGroupReorder', 'tr.entry-group-row', function (e) {
		const groupKey = $(this).data('groupKey');
		if (!groupKey || tbody.data('dragGroupHandle') !== groupKey) {
			e.preventDefault();
			return false;
		}

		const event = e.originalEvent;
		event.dataTransfer.effectAllowed = 'move';
		event.dataTransfer.setData('text/plain', String(groupKey));
		tbody.data('draggingGroupKey', groupKey);
		$(this).addClass('entry-group-dragging');
	});

	tbody.on('dragover.entryGroupReorder', 'tr.entry-group-row', function (e) {
		e.preventDefault();
		const draggingGroupKey = tbody.data('draggingGroupKey');
		const targetGroupKey = $(this).data('groupKey');
		if (!draggingGroupKey || !targetGroupKey || draggingGroupKey === targetGroupKey)
			return;

		const draggingBlock = collectGroupBlockRows(tbody, draggingGroupKey);
		const targetBlock = collectGroupBlockRows(tbody, targetGroupKey);
		if (!draggingBlock.length || !targetBlock.length)
			return;

		const rect = this.getBoundingClientRect();
		const insertBefore = e.originalEvent.clientY < rect.top + rect.height / 2;
		if (insertBefore)
			targetBlock.first().before(draggingBlock);
		else
			targetBlock.last().after(draggingBlock);

		tbody.find('tr.entry-group-row').removeClass('entry-group-drag-over');
		$(this).addClass('entry-group-drag-over');
	});

	tbody.on('dragend.entryGroupReorder', 'tr.entry-group-row', function () {
		tbody.find('tr.entry-group-row').removeClass('entry-group-drag-over entry-group-dragging');
		tbody.removeData('draggingGroupKey');
		tbody.removeData('dragGroupHandle');
	});

	tbody.on('drop.entryGroupReorder', 'tr.entry-group-row', function (e) {
		e.preventDefault();
		tbody.find('tr.entry-group-row').removeClass('entry-group-drag-over');
		tbody.removeData('dragGroupHandle');
	});
}

function initGroupHeaderFilterSwitch() {
	const tbody = $('#entriesFreezeTable > table tbody#entriesTable');
	if (!tbody.length)
		return;

	tbody.off('.entryGroupFilterSwitch');
	tbody.on('click.entryGroupFilterSwitch', 'tr.entry-group-row', function (e) {
		if ($(e.target).closest('.entry-group-drag-handle').length)
			return;
		if (tbody.data('draggingGroupKey'))
			return;

		const modal = $('div#editInventory');
		const filter = modal.find('select#entryGroupFilter');
		if (!filter.length)
			return;

		const selectedGroupKey = (filter.val() || '').toString();
		if (!selectedGroupKey)
			return;

		const targetGroupKey = ($(this).data('groupKey') || '').toString();
		if (!targetGroupKey || targetGroupKey === selectedGroupKey)
			return;

		filter.val(targetGroupKey).trigger('change');
	});
}

function rebuildEntryGroups() {
	const tbody = $('#entriesFreezeTable > table tbody#entriesTable');
	if (!tbody.length)
		return;

	const entryRows = tbody.find('tr.selectable').toArray();
	tbody.find('tr.entry-group-row').remove();

	if (!entryRows.length) {
		updateEntryGroupFilterOptions([]);
		applyEntryNameFilter();
		initEntryReorder();
		initGroupReorder();
		return;
	}

	const groups = [];
	const groupMap = {};

	entryRows.forEach(row => {
		const groupInfo = getEntryGroupInfo(row);
		if (!groupMap[groupInfo.key]) {
			groupMap[groupInfo.key] = {
				key: groupInfo.key,
				name: groupInfo.name,
				rows: []
			};
			groups.push(groupMap[groupInfo.key]);
		}
		groupMap[groupInfo.key].rows.push(row);
	});

	const showGroupHeaders = groups.length > 1;
	const fragment = $(document.createDocumentFragment());

	groups.forEach(group => {
		if (showGroupHeaders) {
			const groupRow = $('<tr class="entry-group-row" data-group-key="' + group.key + '"></tr>');
			const leadingCell = $('<td class="product-image entry-group-leading"></td>');
			const cell = $('<td id="product" tabIndex1="2" class="selectable entry-group-cell" level="3" style="grid-column-start:2;grid-column-end:4"></td>');
			const mobileTitle = $('<span class="mobile-only no-thumbs"></span>');
			const content = $('<div class="entry-group-content"></div>');
			const handle = $('<span class="entry-group-drag-handle hide-print" title="Drag group">|||</span>');
			const leadingPlaceholder = $('<div class="entry-group-leading-placeholder" style="flex-grow:1"></div>');
			const title = $('<span class="entry-group-title"></span>').text(group.name + ' ');
			const count = $('<span class="entry-group-count"></span>').text('(' + group.rows.length + ')');
			leadingCell.append(handle).append(leadingPlaceholder);
			content.append(title).append(count);
			cell.append(mobileTitle).append(content);
			groupRow.append(leadingCell).append(cell);
			fragment.append(groupRow);
		}

		group.rows.forEach(row => {
			$(row).attr('data-group-key', group.key);
			fragment.append(row);
		});
	});

	tbody.append(fragment);

	updateEntryGroupFilterOptions(groups);
	applyEntryNameFilter();
	initEntryReorder();
	initGroupReorder();
	initGroupHeaderFilterSwitch();
}

function applyEntryNameFilter() {
	const modal = $('div#editInventory');
	const filter = normalizeEntryFilterText(modal.find('input#entryNameFilter').val());
	const selectedGroupKey = (modal.find('select#entryGroupFilter').val() || '').toString();
	const rows = modal.find('#entriesFreezeTable > table tbody#entriesTable tr.selectable');
	rows.each((ind, row) => {
		const name = normalizeEntryFilterText(getEntryFilterableName(row));
		const rowGroupKey = ($(row).attr('data-group-key') || '').toString();
		const groupVisible = !selectedGroupKey || selectedGroupKey === rowGroupKey;
		const visible = groupVisible && (!filter || name.indexOf(filter) !== -1);
		$(row).toggleClass('entry-filter-hidden', !visible);
	});

	const tbody = modal.find('#entriesFreezeTable > table tbody#entriesTable');
	tbody.find('tr.entry-group-row').each((ind, groupRow) => {
		if (selectedGroupKey) {
			$(groupRow).show();
			return;
		}

		let hasVisibleEntry = false;
		let next = $(groupRow).next();
		while (next.length && !next.hasClass('entry-group-row')) {
			if (next.hasClass('selectable') && !next.hasClass('entry-filter-hidden')) {
				hasVisibleEntry = true;
				break;
			}
			next = next.next();
		}
		$(groupRow).toggle(!filter || hasVisibleEntry);
	});
}

function initEntryReorder() {
	const tbody = $('#entriesFreezeTable > table tbody#entriesTable');
	if (!tbody.length)
		return;

	const entryRowSelector = 'tr.selectable:not(.entry-group-row)';
	tbody.off('.entryReorder');
	tbody.find(entryRowSelector).removeAttr('draggable');

	if (!isInventoryDndEnabled())
		return;

	tbody.find(entryRowSelector).attr('draggable', true);

	tbody.on('mousedown.entryReorder touchstart.entryReorder', '.entry-drag-handle', function () {
		tbody.data('dragHandleRow', $(this).closest('tr')[0]);
	});

	tbody.on('dragstart.entryReorder', entryRowSelector, function (e) {
		const armedRow = tbody.data('dragHandleRow');
		if (armedRow !== this) {
			e.preventDefault();
			return false;
		}
		const event = e.originalEvent;
		event.dataTransfer.effectAllowed = 'move';
		event.dataTransfer.setData('text/plain', 'drag');
		tbody.data('draggingRow', this);
		$(this).addClass('entry-dragging');
	});

	tbody.on('dragend.entryReorder', entryRowSelector, function () {
		const hadDraggingRow = !!tbody.data('draggingRow');
		tbody.find(entryRowSelector).removeClass('entry-drag-over entry-dragging');
		tbody.removeData('draggingRow');
		tbody.removeData('dragHandleRow');
		if (hadDraggingRow)
			rebuildEntryGroups();
	});

	tbody.on('dragover.entryReorder', entryRowSelector, function (e) {
		e.preventDefault();
		const dragging = tbody.data('draggingRow');
		if (!dragging || dragging === this)
			return;
		const rect = this.getBoundingClientRect();
		const insertBefore = e.originalEvent.clientY < rect.top + rect.height / 2;
		if (insertBefore)
			this.parentNode.insertBefore(dragging, this);
		else
			this.parentNode.insertBefore(dragging, this.nextSibling);

		tbody.find(entryRowSelector).removeClass('entry-drag-over');
		$(this).addClass('entry-drag-over');
	});

	tbody.on('drop.entryReorder', entryRowSelector, function (e) {
		e.preventDefault();
		tbody.find(entryRowSelector).removeClass('entry-drag-over');
		tbody.removeData('dragHandleRow');
	});
}

function updateHooks() {
	$('#entriesFreezeTable > table#entriesTable tfoot .input_count.count').each(function (ind, i) {
		var c = $(i).data('cleave', new Cleave(i, {
			numeral: true,
			numeralThousandsGroupStyle: 'thousand',
			numeralPositiveOnly: true,
			numeralDecimalScale: 3,
			delimiter: ' ',
			numeralDecimalMark: numeralDecimalMark,
		}));
		i.data('cleave', c);
	})
	$('#entriesFreezeTable > table#entriesTable tfoot .input_count.ocount').each(function (ind, i) {
		var c = $(i).data('cleave', new Cleave(i, {
			numeral: true,
			numeralThousandsGroupStyle: 'thousand',
			numeralPositiveOnly: false,
			numeralDecimalScale: 3,
			delimiter: ' ',
			numeralDecimalMark: numeralDecimalMark,
		}));
		i.data('cleave', c);
	})
	$('#entriesFreezeTable > table#entriesTable tfoot .input_count.ovaluediff').each(function (ind, i) {
		var c = $(i).data('cleave', new Cleave(i, {
			numeral: true,
			numeralThousandsGroupStyle: 'thousand',
			numeralPositiveOnly: false,
			numeralDecimalScale: 3,
			delimiter: ' ',
			numeralDecimalMark: numeralDecimalMark,
		}));
		i.data('cleave', c);
	})

	$('div#editInventory').on('hidden.bs.modal', function (event) {
		$('#entrylist').removeClass("hidden");
		$('.menuItemHeader').removeClass("hidden");
		var modal = $(this);
		var id = modal.find('#id').val();
		if (!id && draftId) {
			_deleteInventory(draftId, loadInventories);
		}
		modal.find('#entriesFreezeTable > table#entriesTable tbody tr').remove();
		modal.find('input#entryNameFilter').val("");
		modal.find('select#entryGroupFilter').val('');
		if (saveDraft) {
			clearInterval(saveDraft);
			saveDraft = null;
		}
	});

	const exportit = (array, stores, stocks) => {

		const quantities = [];
		stores.forEach(store => {
			quantities.push("s_" + store.name);
		})
		quantities.sort((a, b) => ("" + a).localeCompare("" + b));
		var r = [];
		array.forEach(m => {
			const path = menuitemutil._getPath(getMenuCategoryAdmin(m.menuCategoryId)).split("/");
			if (m.id == 280) {
				console.log(m);
			}
			//getLocale(m.name).split("/").forEach(() => path.pop());
			//const iq = m.availableQuantities.find(q => q.quantity == menuitemutil.getInventoryQuantity(m));
			m.availableQuantities.filter(a => a.inventoryItem).map(a => {
				const c = {
					id: m.id,
					gid: m.globalId,					
					category: path.join("/"),
					name: getLocale(m.name),
					manufacturer: m.manufacturer,
					label: m.labels.map(l => l.name).join(" / "),
					quantityType: m.quantityType,
					"inventory quantity unit": a.quantity
				}
				stores.forEach(store => {
					c["s_" + store.name] = "";
				})
				r.push(c);
			})
		})
		return r;
	}

	$("#download").click(function (e) {
		const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		get("adminService/" + localStorage.restaurantSelected + "/getStores").done(stores => {
			get("adminService/" + localStorage.restaurantSelected + "/getStocks").done(stock => {
				const ws = window.XLSX.utils.json_to_sheet(exportit(menuitemutil.getFlatMenuItems([], admin.categories.children).filter(m => m.defaultInventoryItem), stores, stock));

				const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
				const excelBuffer = window.XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
				const data = new Blob([excelBuffer], { type: fileType });

				saveAs(data, auth.myStatus.restaurant_name + "s.xlsx");
			});
		});

	});

	$("#upload").click(function () {
		$("#file").attr("files", "");
		$("#file").get(0).value = null;
		$("#file").click();
	});

	$("#file").change(function () {
		if (document.getElementById("file").files[0] == "") return;
		var reader = new FileReader();

		function uploadInventries(storesMap) {
			if (Object.keys(storesMap).length === 1) {
				const id = Object.keys(storesMap)[0];
				inventories.uploadeddata.store = inventories.stores.find(s => s.id === Number(id));
				inventories.uploadeddata.entries = storesMap[id];
				$("#edit").prop("disabled", false);
				$("#edit").trigger('click');
				$("#edit").prop("disabled", true);
			} else {
				choiceDialog2(I18n.t('local.question'), I18n.t('admin_local.select_store'), Object.keys(storesMap).map(id => {
					const store = inventories.stores.find(s => s.id === Number(id));
					return store.name
				}
				)).done(storeId => {
					if (storeId < Object.keys(storesMap).length) {
						storeId = Number(Object.keys(storesMap)[storeId]);
						inventories.uploadeddata.store = inventories.stores.find(s => s.id === storeId);
						inventories.uploadeddata.entries = storesMap[storeId];
						$("#edit").prop("disabled", false);
						$("#edit").trigger('click');
						$("#edit").prop("disabled", true);
					}
				}
				);
			}
		}

		reader.addEventListener("load", () => {
			try {

				var workbook = window.XLSX.read(reader.result, { type: "binary" });
				const firstSheet = workbook.SheetNames && workbook.SheetNames.length ? workbook.SheetNames[0] : null;
				if (!firstSheet) return;
				const rowObject = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
				if (detectInventoryExcelFormat(rowObject)) {
					importEditableInventoryRowsForSelectedInventory(document.getElementById("file").files[0]);
					return;
				}

				workbook.SheetNames.forEach(sheet => {
					let rowObject = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);

					inventories.uploadeddata = {
						entries: []
					};
					let queue = 0;
					const storesMap = {};
					admin.getStores(stores => {
						inventories.stores = stores;
						queue++;
						const notFoundMenuItems = [];
						rowObject.map(row => {
							if ((row.id && (!isNaN(row.id)) || (row.gid && (!isNaN(row.gid))))) {
								queue++;
								getMenuItem(row.id, row.gid, menuItem => {
									if (!menuItem) {
										notFoundMenuItems.push((row.id || row.gid) + " " + row.name);
									}
									Object.keys(row).filter(key => key.startsWith("s_") && row[key] !== "").forEach(key => {
										const storeName = key.substring(2);
										const store = stores.find(s => s.name === storeName);
										//inventories.uploadeddata.store = store;

										if (store && menuItem) {
											if (storesMap[store.id] === undefined)
												storesMap[store.id] = [];
											//inventories.uploadeddata.entries.push({
											storesMap[store.id].push({
												menuItem: { id: menuItem.id, type: menuItem.entityType.toLowerCase() },
												quantityType: row.quantityType,
												quantity: row["inventory quantity unit"],
												count: row[key],
												store: store
											});
										}
									})
									queue--;
									if (!queue) {
										if (notFoundMenuItems.length) {
											messageDialog(I18n.t('admin_local.the_following_products_were_not_found'), notFoundMenuItems.join("<br>"));
										}

										uploadInventries(storesMap);
										/*
										$("#edit").prop("disabled", false);
										$("#edit").trigger('click');
										$("#edit").prop("disabled", true);
										*/
									}
								});
							} else {
								//queue--;
							}
						});
						queue--;
						if (!queue) {
							if (notFoundMenuItems.length) {
								messageDialog(I18n.t('admin_local.the_following_products_were_not_found'), notFoundMenuItems.join("<br>"));
							}

							uploadInventries(storesMap);
							/*
							$("#edit").prop("disabled", false);
							$("#edit").trigger('click');
							$("#edit").prop("disabled", true);
							*/
						}
					});

				});

				/*
				  const newmenuItems = JSON.parse(reader.result);
				  */
			} catch (ex) {
				console.log(ex);
			}

		},
			false
		);


		//if (file) {
		reader.readAsBinaryString(document.getElementById("file").files[0]);
		//}

	});



	$('div#editInventory').on('shown.bs.modal', function (event) {

		draftId = null;

		$('#entrylist').addClass("hidden");
		$('.menuItemHeader').addClass("hidden");

		var modal = $(this)

		var button = $(event.relatedTarget) // Button that triggered the modal
		var recipient = button.data('whatever') // Extract info from data-*
		const templateMode = isTemplateMode();
		const templateRecord = modal.find('#templateRecord').val() === 'true';
		if (templateMode && !canUseInventoryTemplates()) {
			modal.modal('hide');
			return;
		}
		updateInventoryColumnsForTemplate(templateRecord || templateMode);
		modal.find('#exportInventoryFooter').toggle(!templateMode);
		modal.find('#saveAsTemplate').toggle(hasInventoryTemplateAccess('add'));
		modal.find('#templateSourceWrap').toggle(recipient !== 'edit' && !templateMode);
		modal.find('#inventoryTemplateSource').off('change.templateSource').on('change.templateSource', function () {
			applyTemplateToModal($(this).val());
		});
		if (!templateMode && recipient !== 'edit') {
			loadInventoryTemplates(() => {
				updateTemplateSourceOptions();
				modal.find('#inventoryTemplateSource').val('');
			});
		}
		modal.find('#entriesFreezeTable > table#entriesTable tbody tr').remove();
		// attributes
		if (recipient === 'edit') {
			var data;
			if (inventories.uploadeddata) {
				data = inventories.uploadeddata;
				delete inventories.uploadeddata;
				if (!data || !data.store || !data.store.id) {
					modal.find('select#store').select2('open');
				}
			} else {
				if (!inventories.inventories.getActiveNode()) {
					modal.hide();
					$('.modal-backdrop').remove();
					return;
				}
				data = inventories.inventories.getActiveNode().data;
				modal.find('#id').val(data.id);
			}

			modal.find('#id').val(data.id);
			var formattedDate = moment(data.date).format('YYYY-MM-DD');
			modal.find('input#date').val(formattedDate);
			formattedDate = moment(data.date).format('HH:mm');
			modal.find('input#time').val(formattedDate);
			if (data.store)
				modal.find('select#store').val(data.store.id);
			modal.find('select#store').trigger('change');
			modal.find('input#draft').prop('checked', data.draft);
			modal.find('#templateRecord').val(data.template ? 'true' : 'false');
			modal.find('#templateName').val(data.templateName || '');
			updateInventoryColumnsForTemplate(data.template === true || isTemplateMode());

			$("#entriesFreezeTable > table tbody#entriesTable tr.head select.quantity_type").select2().on('select2:select', function (e) {
				/*
				if (modal.find('tbody#InventoryEntries tr:not(.head)').length === 0)
					if ($("#entriesFreezeTable > table tbody#entriesTable tr.head select.quantity_type").select2('val') !== null)
						addNewEntry();
				*/
				e.preventDefault();
			});
			data.entries.forEach(entryData => {
				const entryRow = addNewEntry(entryData, false);
				updateStockCount($(entryRow), entryData.originalCount);
			});

		} else {
			modal.find('select#store').val(null);
			modal.find('select#store').trigger('change');
			modal.find('#id').val("");
			modal.find('#templateRecord').val(templateMode ? 'true' : 'false');
			modal.find('#templateName').val('');
			updateInventoryColumnsForTemplate(templateMode);
			modal.find('#active').prop("checked", 'true');
			modal.find("tbody#entriesTable tr.head select.quantity_type").select2().on('select2:select', function (e) {
				if (modal.find('tbody#entriesTable tr.selectable').length === 0)
					if ($("#entriesFreezeTable > table tbody#entriesTable tr.head select.quantity_type").select2('val') !== null)
						addNewEntry();
				e.preventDefault();
			});
			var m = moment();
			formattedDate = m.format('YYYY-MM-DD');
			modal.find('input#date').val(formattedDate);
			formattedDate = m.format('HH:mm');
			modal.find('input#time').val(formattedDate);
			//$(".datepicker").datepicker("setDate", new Date());
			$("textarea#regexp").keyup(function (e) {
				var p = $("textarea#regexp").val();
				if (pattern !== p && p !== "" && $("textarea#rawtextdata").val() !== "") {
					tt = new Date().getTime();
					var ttt = tt;
					setTimeout(function () {
						if (ttt === tt) {
							pattern = $("textarea#regexp").val();
							tryExecuteRegexp();
						}
					}, 1000);
				}
				e.preventDefault();
			});
			modal.find('input#draft').prop('checked', false);
			modal.find('select#store').select2('open');
			if (!templateMode) {
				saveDraft = setInterval(() => saveInventory(true), 20000);
			}
		}

		modal.find('#entriesFreezeTable > table input#date').change(() => {
			modal.find('#entriesFreezeTable > table tbody tr.selectable').each((ind, entry) => {
				updateStockCount($(entry));
			})
		});
		modal.find('input#entryNameFilter')
			.off('.entryFilter')
			.on('input.entryFilter keyup.entryFilter', applyEntryNameFilter);
		modal.find('select#entryGroupFilter')
			.off('.entryFilter')
			.on('change.entryFilter', applyEntryNameFilter);
		applyEntryNameFilter();
		modal.find('#entriesFreezeTable > table input#time').change(() => {
			modal.find('#entriesFreezeTable > table tbody tr.selectable').each((ind, entry) => {
				updateStockCount($(entry));
			})
		});

		rebuildEntryGroups();

	})
}

function _addNewEntry2(data, index, tbody) {
	var existingRow = tbody.find('tr:nth-child(' + index + ')');
	if (existingRow.length === 1) {
		existingRow.removeClass('existing');
		Object.keys(data).forEach(function (key) {
			var value = data[key];
			var input = existingRow.find('input#' + key);
			if (input.attr('type') === 'number')
				value = parseNumber(value);
			existingRow.find('input#' + key).val(value);
		});
	} else {
		var entry = $("script#InventoryEntryTemplate").tmpl({ ...data, ...tmplparams() });
		$('#entriesFreezeTable > table tbody#entriesTable').append(entry);
		// admin.initializeSelect2(entry.find('select.select2'));
	}
}
function _updateEntries2() {
	admin.initializeSelect2($('#entriesFreezeTable > table tbody tr.selectable select.select2:not(.select2-hidden-accessible)'));
}

export const addNewEntry = (data2, init = true) => {
	if (!$('#editInventory #store').select2('val')) {
		$('#editInventory #store + span').removeClass('highlight-3');
		setTimeout(() => {
			$('#editInventory #store + span').addClass('highlight-3');
		}, 100)
		return;
	}
	var data;
	$('.select2.select2-container.select2-container--default.select2-container--below.select2-container--open').prev('select').select2('close');
	if (typeof data2 == "undefined")
		data = { store: {}, vatCategory: {}, quantityType: {} }
	else
		data = data2;
	const entry = $("script#InventoryEntryTemplate").tmpl({ ...data, ...tmplparams() });

	if (!viewStock()) {
		entry.find('td[tabIndex1=3]').css('visibility', 'hidden');
	}

	entry.appendTo('div#editInventory #entriesFreezeTable > table tbody');

	if (!init) {
		getMenuItem(data.menuItem.id, null, menuItem => {
			var newOption1 = new Option((menuItem.manufacturer ? menuItem.manufacturer + " / " : "") + getLocale(menuItem.name), menuItem.id, false, false);
			entry.find('select.product').append(newOption1).trigger('change');
			//var newOption2 = new Option(getQuantityForCount(menuItem, data.quantity, 1), data.quantity, false, false);
			var quantityTypes = [];
			menuItem.availableQuantities.forEach((quantity) => {
				if (quantity.inventoryItem === true)
					quantityTypes.push({ id: quantity.quantity + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, quantity.quantity, 1) });
			});
			if (quantityTypes.length === 0) {
				quantityTypes.push({ id: 1 + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, 1, 1) });
			}
			entry.find('select.quantity_type option').remove();
			var qt = entry.find('select.quantity_type');
			const select2 = qt.select2({
				data: quantityTypes
			});
			qt.data('select2', select2);

			entry.find('select.product').select2();
			//entry.find('select.quantity_type').append(newOption2).trigger('change');
			//entry.find('select.quantity_type').select2();

			if (quantityTypes.find(qt => qt.id === (data.quantity + ";" + menuItem.quantityType))) {
				entry.find('select.quantity_type').select2().val(data.quantity + ";" + menuItem.quantityType);
			} else if (menuItem.quantityType === "g" && data.quantity === 1000) {
				entry.find('select.quantity_type').select2().val("1;kg");
			} else if (menuItem.quantityType === "kg" && data.quantity === 1) {
				entry.find('select.quantity_type').select2().val("1000;g");
			}

			entry.find('select.quantity_type').select2().trigger('change');

			updatePattern(entry, menuItem.quantityType);

			entry.find('.input_count.ocount').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: true,
					numeralThousandsGroupStyle: 'thousand',
					numeralPositiveOnly: false,
					numeralDecimalScale: 3,
					delimiter: ' ',
					numeralDecimalMark: numeralDecimalMark,
				}));
			})
			if (viewStock()) {
				entry.find('.input_count.ocount').data("cleave").setRawValue(data.originalCount);
			}
			entry.find('.input_count.count').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: false,
				}));
			})
			const c = calcCount(data.count, menuItem.quantityType, data.quantity);
			var cc = c === undefined ? undefined : Number(c);
			if (c !== undefined) {
				if (isNaN(cc)) cc = Number(c.replace(",", "."));
				if (isNaN(cc)) cc = Number(c.replace(".", ","));
				if (isNaN(cc)) cc = "N/A";
			}
			entry.find('.input_count.count').val(cc);
			entry.find('.input_count.ovaluediff').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: true,
					numeralThousandsGroupStyle: 'thousand',
					numeralPositiveOnly: false,
					numeralDecimalScale: 3,
					delimiter: ' ',
					numeralDecimalMark: numeralDecimalMark,
				}));
			})
			if (viewStock())
				entry.find('input.ovaluediff').data('cleave').setRawValue(Math.round((Math.round(1000 * data.count) / 1000 - Math.round(1000 * data.originalCount) / 1000) * menuItem.cost * menuitemutil.getInventoryQuantity(menuItem, data.quantity)));
			updateDiff();

			function init(item) {
				entry.find('select.product + .select2').unbind("focus", init);
				entry.find('select.quantity_type + .select2').unbind("focus", init);

				var menuItemId = entry.find('select.product').val();
				var quantity = entry.find('select.quantity_type').val();
				entry.find('select.product option').remove();
				entry.find('select.product quantity_type').remove();
				entry.find('select.product').val("");
				entry.find('select.quantity_type').val("");
				admin.initializeSelect2(entry.find('select.product.select2')).done(() => {
					if (menuItemId) {
						getMenuItem(menuItemId, null, menuItem => {
							if (!menuItem.defaultInventoryItem || menuItem.type === "deleted") {
								var newOption = new Option((menuItem.manufacturer ? menuItem.manufacturer + " / " : "") + getLocale(menuItem.name), menuItem.id, false, false);
								entry.find('select.product').append(newOption).trigger('change');
								entry.find('select.product').select2().val(menuItem.id);
								entry.find('select.product').append(newOption).trigger('change');
								//handleProductChange(null, entry);
								checkEntry({ currentTarget: entry });
							}
						});
					}

					var default_quantity_type = data2 ? data.quantityType : undefined;

					entry.find('select.product').on('select2:select', function () {
						var menuItemId = $(this).val();
						if (menuItemId == null) {
							rebuildEntryGroups();
							return;
						}
						getMenuItem(menuItemId, null, menuItem => {
							rebuildEntryGroups();
							updatePattern(entry, menuItem.quantityType);

							var quantityTypes = [];
							menuItem.availableQuantities.forEach((quantity) => {
								if (quantity.inventoryItem === true)
									quantityTypes.push({ id: quantity.quantity + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, quantity.quantity, 1) });
							});
							if (quantityTypes.length === 0) {
								quantityTypes.push({ id: 1 + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, 1, 1) });
							}
							entry.find('select.quantity_type option').remove();
							var qt = entry.find('select.quantity_type');
							const select2 = qt.select2({
								data: quantityTypes
							});
							qt.data('select2', select2);
							if (default_quantity_type) {
								qt.val(quantity + ";" + default_quantity_type);
							} else if (quantityTypes.length > 0)
								qt.val(quantityTypes[0].id);
							//qt.data('select2').trigger('select2:select');
							qt.data('select2').trigger("change");
							setTimeout(() => { updateStockCount(entry, data.ocount) }, 100);
						});
					});

					if (data && data.menuItem) {
						getMenuItem(menuItemId, null, menuItem => {
							entry.find('img.product-image').attr('src', getMenuItemImageUrl(menuItem, quantity));
							entry.find('select.product').val(menuItemId);
							entry.find('select.product').select2().val(menuItemId)
							entry.find('select.product').select2().trigger('change');;
							//entry.find('select.product').trigger('select2:select');
							entry.find('select.quantity_type').val(quantity + ";" + menuItem.quantityType);
						})
					}
					if (default_quantity_type !== null) {
						entry.find('select.quantity_type').select2({
							allowClear: true,
							data: quantityTypes
						});
						if (data.quantity && data.quantityType)
							entry.find('select.quantity_type').select2().val(data.quantity + ";" + default_quantity_type);
						//s.trigger('select2:select');
						entry.find('select.quantity_type').select2().trigger('change');
					}
					setTimeout(() => {
						checkEntry({ currentTarget: entry[0] });
					}, 50);

				});
			}

			entry.find('input').change(checkEntry);
			entry.find('select').select2().change(checkEntry);
			entry.find('select.product').on('change', rebuildEntryGroups);

			entry.find('input.expiry').change(() => {
				updateStockCount(entry);
			});
			entry.find('input.count').change(() => {
				updateStockCount(entry);
			});

			entry.find('select.quantity_type').select2().change(() => {
				updateStockCount(entry);
			});
			entry.find('input.expiry').change(() => {
				updateStockCount(entry);
			});
			entry.find('input.count').change(() => {
				updateStockCount(entry);
			});

			entry.find('select.product + .select2').on("focus", init);
			entry.find('select.quantity_type + .select2').on("focus", init);
		});
		setTimeout(() => checkEntry({ currentTarget: entry[0] }), 50);
		rebuildEntryGroups();

	} else
		admin.initializeSelect2(entry.find('select.select2')).done(function () {
			var menuItemId = $(this).select2('val');
			if (!menuItemId && data.menuItem) menuItemId = data.menuItem.id
			if (menuItemId) {
				getMenuItem(menuItemId, menuItem => {
					if (!menuItem.defaultInventoryItem || menuItem.type === "deleted") {
						var newOption = new Option((menuItem.manufacturer ? menuItem.manufacturer + " / " : "") + getLocale(menuItem.name), menuItem.id, false, false);
						entry.find('select.product').append(newOption).trigger('change');
						entry.find('select.product').select2().val(menuItem.id);
						entry.find('select.product').append(newOption).trigger('change');
						//handleProductChange(null, entry);
						checkEntry({ currentTarget: entry });
					}
				});
			}

			var default_quantity_type = data2 ? data.quantityType : undefined;

			updatePattern(entry, default_quantity_type);

			entry.find('select.product').on('select2:select', function () {
				var menuItemId = $(this).val();
				if (menuItemId == null)
					return;
				getMenuItem(menuItemId, null, menuItem => {
					updatePattern(entry, menuItem.quantityType);

					var quantityTypes = [];
					menuItem.availableQuantities.forEach((quantity) => {
						if (quantity.inventoryItem === true)
							quantityTypes.push({ id: quantity.quantity + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, quantity.quantity, 1) });
					});
					if (quantityTypes.length === 0) {
						quantityTypes.push({ id: 1 + ";" + menuItem.quantityType, text: getQuantityForCount(menuItem, 1, 1) });
					}
					entry.find('select.quantity_type option').remove();
					var qt = entry.find('select.quantity_type');
					const select2 = qt.select2({
						data: quantityTypes
					});
					qt.data('select2', select2);
					if (default_quantity_type) {
						qt.val(data.quantity + ";" + default_quantity_type);
					} else if (quantityTypes.length > 0)
						qt.val(quantityTypes[0].id);
					qt.data('select2').trigger('select2:select');
					setTimeout(() => {
						updateStockCount(entry, data.ocount);
						checkEntry({ currentTarget: entry[0] });
					}, 100);
				});
			});
			if (data && data.menuItem) {
				getMenuItem(data.menuItem.id, menuItem => {
					entry.find('img.product-image').attr('src', getMenuItemImageUrl(menuItem, data.quantity));
					entry.find('select.product').val(data.menuItem.id);
					entry.find('select.product').trigger('select2:select');
					entry.find('select.quantity_type').val(data.quantity);
				})
			}
			if (default_quantity_type !== null) {
				var s = entry.find('select.quantity_type').select2({
					allowClear: true
				});
				s.val(data.quantity + ";" + default_quantity_type);
				s.trigger('select2:select');
			}
			entry.find('.datepicker').datepicker({
				format: 'yyyy-mm-dd',
				uiLibrary: 'bootstrap4'
			});
			if (data.expiryDate) {
				var formattedDate = moment(data.expiryDate).format('YYYY-MM-DD');
				entry.find('input.expiry').val(formattedDate);
			}

			entry.find('input').change(checkEntry);
			entry.find('select').select2().change(checkEntry);
			entry.find('.input_count.count').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: false,
				}));
			})
			entry.find('.input_count.count').val(data.count);

			entry.find('.input_count.ocount').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: true,
					numeralThousandsGroupStyle: 'thousand',
					numeralPositiveOnly: false,
					numeralDecimalScale: 3,
					delimiter: ' ',
					numeralDecimalMark: numeralDecimalMark,
				}));
			})

			entry.find('.input_count.ovaluediff').each(function (ind, i) {
				$(i).data('cleave', new Cleave($(i), {
					numeral: true,
					numeralThousandsGroupStyle: 'thousand',
					numeralPositiveOnly: false,
					numeralDecimalScale: 3,
					delimiter: ' ',
					numeralDecimalMark: numeralDecimalMark,
				}));
			})

			entry.find('select.quantity_type').select2().change(() => {
				updateStockCount(entry);
				setTimeout(() => checkEntry({ currentTarget: entry[0] }), 0);
			});
			entry.find('input.expiry').change(() => {
				updateStockCount(entry);
			});
			entry.find('input.count').change(() => {
				updateStockCount(entry);
			});

			setTimeout(() => checkEntry({ currentTarget: entry[0] }), 50);

			if (data2 === undefined) {
				const div = $("#entriesFreezeTable").get(0);
				div.scrollTop = div.scrollHeight - div.clientHeight;
				entry.find('select.product').select2('open');
			}
			rebuildEntryGroups();

		});


	entry.find('.input_count.count').on("change", (event) => {
		if (!event.currentTarget.checkValidity()) {
			$(event.currentTarget).val($(event.currentTarget).data("value"));
			$(event.currentTarget).trigger('change');
		} else {
			var value = event.currentTarget.value.replace(/,/g, '.');
			if (isNaN(value)) {
				const quantityType = entry.find('select.quantity_type').select2('val').split(';')[1];
				const quantity = entry.find('select.quantity_type').select2('val').split(';')[0];
				const found = value.match("(\\d*[,\\.]?\\d+) ?(cl|dl|l|g|dkg|kg|" + local.pcs + ")");
				if (!found) {
					$(event.currentTarget).val($(event.currentTarget).data("value"));
					$(event.currentTarget).trigger('change');
					return;
				}
				const newValue = calcCount(value, quantityType, quantity);
				$(event.currentTarget).val(newValue);
				$(event.currentTarget).data("value", newValue);
				$(event.currentTarget).trigger('change');
			} else {
				if (value != event.currentTarget.value) {
					$(event.currentTarget).val(value);
					$(event.currentTarget).data("value", value);
					$(event.currentTarget).trigger('change');
				} else
					$(event.currentTarget).data("value", event.currentTarget.value);
			}


		}
	})
	entry.find('.input_count.count').on("keyup", (event) => {
		if (!event.currentTarget.checkValidity()) {
			$(event.currentTarget).addClass("invalid");
		} else {
			$(event.currentTarget).removeClass("invalid");
		}
	})


	return entry;
}

function updatePattern(entry, quantityType) {
	if (quantityType === "dl" || quantityType === "cl" || quantityType === "l") {
		entry.find('.input_count.count').attr("pattern", "(\\d*[,.]?\\d+) ?(l|dl|cl)?")
	} else if (quantityType === "dkg" || quantityType === "g" || quantityType === "kg") {
		entry.find('.input_count.count').attr("pattern", "(\\d*[.,]?\\d+) ?(g|dkg|kg)?")
	} else if (quantityType === "pcs") {
		entry.find('.input_count.count').attr("pattern", "(\\d*[.,]?\\d+) ?(" + local.pcs + ")?")
	} else {
		entry.find('.input_count.count').attr("pattern", "(\\d*[,.]?\\d+)")
	}
}

function updateStockCount(entry, originalcount) {
	if (!viewStock())
		return;
	var modal = $('div#editInventory');

	if (!entry.find('input.count').data('cleave'))
		return;
	var menuItemId = entry.find('select.product').val();
	var count = entry.find('input.count').val();
	var ocount = entry.find('input.ocount').data('cleave').getRawValue();
	var quantity = entry.find('select.quantity_type').val() ? entry.find('select.quantity_type').val().split(";")[0] : 0;
	if (quantity === 0)
		return;
	var dateString = modal.find('input#date').val() + " " + modal.find('input#time').val();
	var date = moment(dateString, "YYYY-MM-DD HH-mm").toDate().getTime();
	var store = modal.find('select#store').select2('val');
	var expiry = new Date(entry.find('input.expiry').val()).getTime();
	if (isNaN(expiry))
		expiry = "";
	var key = menuItemId + "-" + quantity + "-" + date + "-" + store + "-" + expiry;
	getMenuItem(menuItemId, null, menuItem => {
		entry.find('input.ovaluediff').data('cleave').setRawValue(Math.round((Math.round(1000 * count) / 1000 - Math.round(1000 * ocount) / 1000) * menuItem.cost * menuitemutil.getInventoryQuantity(menuItem, quantity)));
		updateDiff();
	});
	if ($(entry).data('key') === key)
		return;
	$(entry).data('key', key);

	if (typeof originalcount !== "undefined") {
		if (entry.find('input.ocount').data('cleave')) {
			entry.find('input.ocount').data('cleave').setRawValue(originalcount);
			getMenuItem(menuItemId, null, menuItem => {
				entry.find('input.ovaluediff').data('cleave').setRawValue(Math.round((Math.round(1000 * count) / 1000 - Math.round(1000 * originalcount) / 1000) * menuItem.cost * menuitemutil.getInventoryQuantity(menuItem, quantity)));
				updateDiff();
			});
		}
		delete entry.ocount;
	} else {
		admin.getCostAndPriceHistoryAt(menuItemId, quantity, store, expiry, date, data => {
			if (entry.find('input.ocount').data('cleave')) {
				data.count = Math.round(1000 * data.count) / 1000;
				entry.find('input.ocount').data('cleave').setRawValue(data.count);
				getMenuItem(menuItemId, null, menuItem => {
					entry.find('input.ovaluediff').data('cleave').setRawValue(Math.round((Math.round(1000 * count) / 1000 - data.count) * menuItem.cost * menuitemutil.getInventoryQuantity(menuItem, quantity)));
					updateDiff();
				});
			}
		}, data => {
			entry.find('input.ocount').data('cleave').setRawValue(0);
		})
	}
}

const updateDiff = () => {
	if (!viewStock())
		return;
	var diff = 0;
	$('#entriesFreezeTable > table tbody#entriesTable input.ovaluediff').each((ind, e) => {
		if ($(e).data('cleave')) {
			diff += Number($(e).data('cleave').getRawValue());
		}
	});
	$('#entriesFreezeTable > table tfoot input#value-difference').data('cleave').setRawValue(diff);

}

export const saveInventory = (draft, saveAsTemplate, providedTemplateName) => {
	if (!draft) {
		clearInterval(saveDraft);
		saveDraft = null;
	}
	var modal = $('div#editInventory');
	const templateRecord = modal.find('#templateRecord').val() === 'true';
	if (saveAsTemplate && typeof providedTemplateName === 'undefined') {
		const defaultTemplateName = (modal.find('#templateName').val() || '').trim();
		getInputDialog(
			I18n.t('local.question'),
			I18n.t('admin_local.template_name'),
			defaultTemplateName,
			"text"
		).done((choice, templateNameInput) => {
			const templateName = (templateNameInput || '').trim();
			if (!templateName) {
				messageDialog(I18n.t('local.error_message'), I18n.t('admin_local.template_name_required'));
				return;
			}
			saveInventory(draft, true, templateName);
			modal.modal('hide');
		});
		return;
	}
	var id = modal.find('#id').val();
	var inventory = {};
	inventory.date = new moment(modal.find('input#date').val() + " " + modal.find('input#time').val(), "YYYY-MM-DD HH-mm").toDate().getTime();
	inventory.store = { id: modal.find('select#store').select2('val') };
	inventory.entries = [];
	inventory.draft = id || !draft ? modal.find('input#draft').prop('checked') : true;
	inventory.template = templateRecord;
	inventory.templateName = inventory.template ? ((providedTemplateName || modal.find('#templateName').val() || '').trim()) : null;
	if (saveAsTemplate) {
		inventory.template = true;
		inventory.templateName = (providedTemplateName || '').trim();
		id = "";
	}

	if (!inventory.store.id)
		return;

	const aggregatedEntries = {};
	const entries = [];

	modal.find('#entriesFreezeTable > table tbody#entriesTable tr.selectable').each(function (ind, e) {
		var entry = {};
		try {
			var product = $(e).find('select.product').select2('val');;
			if (product === null)
				return;
			const menuItem = getMenuItem(product);
			entry.menuItem = { id: product, type: menuItem.entityType.toLowerCase() };
			entry.quantity = $(e).find('select.quantity_type').select2('val').split(';')[0];
			entry.quantityType = $(e).find('select.quantity_type').select2('val').split(';')[1];
			entry.id = $(e).attr('id');
			entry.entryOrder = ind;
			entry.count = $(e).find('input.count').val();
			entry.originalCount = $(e).find('input.ocount').data('cleave').getRawValue();
			entry.expiryDate = new Date($(e).find('input.expiry').val()).getTime();
		} catch (ex) {

		}
		if (entry.menuItem && entry.menuItem.id) {
			const expiryKey = isNaN(entry.expiryDate) ? '' : entry.expiryDate;
			const key = entry.menuItem.id + '|' + entry.quantity + '|' + entry.quantityType + '|' + expiryKey;
			if (!aggregatedEntries[key]) {
				aggregatedEntries[key] = entry;
				aggregatedEntries[key].count = parseNumber(entry.count) || 0;
				aggregatedEntries[key].originalCount = parseNumber(entry.originalCount) || 0;
				entries.push(e);
			} else {
				aggregatedEntries[key].count += parseNumber(entry.count) || 0;
				aggregatedEntries[key].originalCount += parseNumber(entry.originalCount) || 0;
			}
		}
	});

	inventory.entries = Object.keys(aggregatedEntries).map(key => aggregatedEntries[key]);


	if (!id && draftId) {
		id = draftId;
	}

	if (draft && inventory.store.id && inventory.entries.length === 0)
		return;

	if (!draft)
		draftId = null;

	if (id !== '') {
		inventory.id = id;
		modifyInventory(inventory, data => {
			if (!draft) {
				draftId = null;
				loadInventories(data);
			}
			entries.forEach((e, ind) => {
				$(e).attr('id', data.entries[ind].id);
			});
		});
	} else {
		addInventory(inventory, data => {
			if (draft)
				draftId = data.id;
			else
				draftId = null;
			entries.forEach((e, ind) => {
				$(e).attr('id', data.entries[ind].id);
			});
			if (!draft)
				loadInventories(data);
		});
	}
}

export const deleteInventory = () => {
	var data = inventories.inventories.getActiveNode().data;
	confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.are_you_sure_you_want_to_delete_the_inventory")).done(function () {
		_deleteInventory(data.id, loadInventories);
	});

}

function addInventory(Inventory, handler, errorHandler) {
	executeLongJob("", "adminService/" + localStorage.restaurantSelected + "/addInventory?lang=" + localStorage.language, false, Inventory).done(function (data) { resultHandler(data, handler, errorHandler) });
}

function modifyInventory(Inventory, handler, errorHandler) {
	executeLongJob("", "adminService/" + localStorage.restaurantSelected + "/modifyInventory?lang=" + localStorage.language, false, Inventory).done(function (data) {
		console.log("finished");
		resultHandler(data, handler, errorHandler)
	});
}

function _deleteInventory(id, handler, errorHandler) {
	executeLongJob("", "adminService/" + localStorage.restaurantSelected + "/deleteInventory/" + id + "?lang=" + localStorage.language, false).done(function (data) { resultHandler(data, handler, errorHandler) });
}

export const checkEntry = (e) => {
	var ok = true;
	var entry = e.currentTarget.localName === 'tr' ? $(e.currentTarget) : $(e.currentTarget).parents('tr');
	const isTemplateEntry = isTemplateMode() || $('div#editInventory #templateRecord').val() === 'true';
	const countValue = entry.find('input.count').val();
	if (isTemplateEntry) {
		ok = ok && (countValue === undefined || countValue === '' || parseNumber(countValue) >= 0);
	} else {
		const v = countValue ? parseNumber(countValue) : undefined;
		ok = ok && v !== undefined && v !== "" && v >= 0;
	}
	var v = parseNumber(entry.find('select.product').select2('val'));
	ok = ok && v !== undefined && v !== "" && v > 0;
	const selectedQuantityType = entry.find('select.quantity_type').select2('val');
	if (selectedQuantityType === null || selectedQuantityType === undefined || String(selectedQuantityType).trim() === '') {
		entry.removeClass('error');
		updateDiff();
		$('button#save').attr('disabled', false);
		return;
	}
	v = parseNumber(String(selectedQuantityType).split(';')[0]);
	ok = ok && v !== undefined && v !== "" && v > 0;
	v = new Date(entry.find('input.expiry').val()).getTime();
	ok = ok && (isNaN(v) || v > 0);
	if (ok) {
		entry.removeClass('error');
	} else {
		entry.addClass('error');
	}

	updateDiff();
	$('button#save').attr('disabled', $('#entriesFreezeTable > table tbody#entriesTable tr.error').length > 0)
}

export const deleteEntry = (e) => {
	var entry = e.currentTarget.localName === "tr" ? $(e.currentTarget) : $(e.currentTarget).parents("tr");
	var p = entry.next();
	if (p.length === 0) p = entry.prev();

	var column = entry.find(":focus");
	var td = column.parents("td");
	var tds = entry.find("td");
	var index = tds.toArray().indexOf(td[0]) + 1;

	entry.remove();
	rebuildEntryGroups();
	$("button#save").attr("disabled", $("#entriesFreezeTable > table tbody#entriesTable tr.error").length > 0);
	if (p.length === 1) {
		$(getKeyboardFocusableElements(p)).trigger('focus');
		td = p.find("td:nth-child(" + index + ")");
		$(getKeyboardFocusableElements(td)).trigger('focus');
	}
}


function tryExecuteRegexp() {
	try {
		// $('table tbody tr:not(.head)').remove();
		var tbody = $('#entriesFreezeTable > table tbody#entriesTable');
		var regexp = $('textarea#regexp').val();
		var text = $('textarea#rawtextdata').val();
		regexp = new RegExp(regexp, 'ig');
		tbody.find('tr.selectable').addClass('existing');
		if (regexp.test(text)) {
			var m;
			var index = 2;
			do {
				m = regexp.exec(text);
				if (m !== null && m.groups) {
					console.log(index);
					console.log(m.groups);
					_addNewEntry2(m.groups, index, tbody);
				}
				index++;
			} while (m !== null && m.groups);
		}
		tbody.find('tr.selectable.existing').remove();
		_updateEntries2();
	} catch (ex) {
		console.log(ex);
	}
}

export const findEntry = (item, inventoryQuantity) => {
	const entries = $('table#entriesTable tbody tr.selectable');
	var entry = entries.filter((ind, entry) => {
		const product = Number($(entry).find('select.product').select2('val'));
		if (product !== item)
			return false;
		const quantityType = $(entry).find('select.quantity_type').val();
		const res = quantityType && Number(quantityType.split(";")[0]) === inventoryQuantity;
		return res;
	})
	return entry;
}

var deletedMenuItems = {}
function getMenuItem(id, globalId, handler) {
	var menuItem = _getMenuItem(id, globalId, inventories.categories.activeMenuCategories ? inventories.categories.activeMenuCategories : inventories.categories.children);
	if (menuItem === null || menuItem === '') {
		if (deletedMenuItems[id]) {
			if (handler)
				handler(deletedMenuItems[id]);
			return menuItem;
		}
		if (handler && globalId) {
			getMenuItemByGlobalId(globalId, menuItem => {
				menuItem.type = 'deleted';
				menuItem.name = admin_local.deleted + ' --- ' + getLocale(menuItem.name) + " --- ";
				deletedMenuItems[menuItem.id] = menuItem;
				if (handler)
					handler(menuItem);
			}, () => {
				if (handler)
					handler(null);
			});
			return menuItem;
		} else if (handler && id) {
			getMenuItemById(id, menuItem => {
				menuItem.type = 'deleted';
				menuItem.name = admin_local.deleted + ' --- ' + getLocale(menuItem.name) + " --- ";
				deletedMenuItems[id] = menuItem;
				if (handler)
					handler(menuItem);
			}, () => {
				if (handler)
					handler(null);
			});
		} else {
			menuItem = {};
			menuItem.type = 'deleted';
			menuItem.name = admin_local.deleted + ' --- ' + getLocale(menuItem.name) + " --- ";
			if (handler)
				handler(menuItem);
		}
		return;
	}
	if (handler)
		handler(menuItem);
	return menuItem;
}

function _getMenuItem(id, globalId, categories) {
	var val = null;
	categories.forEach(function (item) {
		if (val !== null)
			return;
		if (item.entityType.indexOf('Category') === -1 && (globalId ? item.globalId === Number(globalId) : item.id === Number(id))) {
			val = Object.assign({}, item);
			delete val.image;
		} else {
			if (item.activeMenuCategories && item.activeMenuCategories.length > 0)
				val = _getMenuItem(id, globalId, item.activeMenuCategories);
			if (val === null && item.activeMenuItems && item.activeMenuItems.length > 0)
				val = _getMenuItem(id, globalId, item.activeMenuItems);
			if (val === null && item.children && item.children.length > 0)
				val = _getMenuItem(id, globalId, item.children);
		}
	});
	return val;
}

function getStore(id) {
	var store = null;
	inventories.stores.forEach(s => {
		if (s.id === Number(id))
			store = s;
	});
	return store;
}

export const setSelectedScale = (scale) => {
	localStorage.selected_scale = scale;
	$('#editInventory #selectedScale').html(scale);
}

function getRootMenuNodes() {
	if (!inventories.categories)
		return [];
	return inventories.categories.activeMenuCategories || inventories.categories.children || [];
}

function collectMenuCategories(nodes, categories = [], path = [], seen = {}) {
	if (!nodes || !nodes.length)
		return categories;

	nodes.forEach(node => {
		if (!node)
			return;

		const isCategory = node.entityType && node.entityType.indexOf('Category') !== -1;
		let nextPath = path;

		if (isCategory) {
			if (seen[node.id])
				return;
			seen[node.id] = true;
			nextPath = path.concat([getLocale(node.name)]);
			categories.push({
				id: Number(node.id),
				name: nextPath.join(' / '),
				parentId: node.parentCategory ? Number(node.parentCategory.id) : null
			});
		}

		collectMenuCategories(node.activeMenuCategories, categories, nextPath, seen);
		collectMenuCategories(node.children, categories, nextPath, seen);
	});

	return categories;
}

function getCategoryItemMappings() {
	const categoryItems = {};
	const itemCategories = {};

	function walk(nodes, categoryPath = []) {
		if (!nodes || !nodes.length)
			return;

		nodes.forEach(node => {
			if (!node)
				return;

			const isCategory = node.entityType && node.entityType.indexOf('Category') !== -1;
			if (isCategory) {
				const categoryId = Number(node.id);
				const nextCategoryPath = categoryPath.concat([categoryId]);
				walk(node.activeMenuCategories, nextCategoryPath);
				walk(node.children, nextCategoryPath);
				walk(node.activeMenuItems, nextCategoryPath);
				return;
			}

			const itemId = Number(node.id);
			if (itemId > 0) {
				itemCategories[itemId] = itemCategories[itemId] || new Set();
				categoryPath.forEach(categoryId => {
					if (!categoryItems[categoryId])
						categoryItems[categoryId] = new Set();
					categoryItems[categoryId].add(itemId);
					itemCategories[itemId].add(categoryId);
				});
			}

			walk(node.children, categoryPath);
			walk(node.activeMenuItems, categoryPath);
		});
	}

	walk(getRootMenuNodes(), []);
	return { categoryItems, itemCategories };
}

function getSelectedCategoryAndChildren(selectedIds) {
	const categories = collectMenuCategories(getRootMenuNodes());
	const childrenByParent = {};

	categories.forEach(category => {
		if (!childrenByParent[category.parentId]) {
			childrenByParent[category.parentId] = [];
		}
		childrenByParent[category.parentId].push(category.id);
	});

	const categorySet = new Set();
	const stack = selectedIds.slice();

	while (stack.length) {
		const categoryId = Number(stack.pop());
		if (!categoryId || categorySet.has(categoryId))
			continue;

		categorySet.add(categoryId);
		(childrenByParent[categoryId] || []).forEach(childId => stack.push(childId));
	}

	return categorySet;
}

function getSelectedMenuItemIds(selectedCategoryIds) {
	const selectedRootCategories = new Set((selectedCategoryIds || []).map(id => Number(id)).filter(id => !!id));
	const selectedMenuItemIds = new Set();

	function walk(nodes, includeAllDescendants = false) {
		if (!nodes || !nodes.length)
			return;

		nodes.forEach(node => {
			if (!node)
				return;

			const isCategory = node.entityType && node.entityType.indexOf('Category') !== -1;
			if (isCategory) {
				const includeThisCategory = includeAllDescendants || selectedRootCategories.has(Number(node.id));
				walk(node.activeMenuCategories, includeThisCategory);
				walk(node.children, includeThisCategory);
				walk(node.activeMenuItems, includeThisCategory);
				return;
			}

			if (includeAllDescendants) {
				selectedMenuItemIds.add(Number(node.id));
			}
			walk(node.children, includeAllDescendants);
			walk(node.activeMenuItems, includeAllDescendants);
		});
	}

	walk(getRootMenuNodes(), false);
	return selectedMenuItemIds;
}

function showCategoryExtractDialog() {
	const def = $.Deferred();
	const categories = collectMenuCategories(getRootMenuNodes()).sort((a, b) => a.name.localeCompare(b.name));
	let selectedCategoryIds = [];

	if (!categories.length) {
		messageDialog(I18n.t('local.error_message'), I18n.t('admin_local.select_a_category'));
		return def.reject().promise();
	}

	if (!$('#editInventory #store').select2('val')) {
		$('#editInventory #store + span').removeClass('highlight-3');
		setTimeout(() => {
			$('#editInventory #store + span').addClass('highlight-3');
		}, 100);
		return def.reject().promise();
	}

	const existingEntries = new Set();
	$('#entriesFreezeTable tbody tr.selectable').each((ind, row) => {
		const product = Number($(row).find('td#product select').select2('val'));
		const quantityType = $(row).find('td#quantity select.quantity_type').select2('val');
		if (!product || !quantityType)
			return;
		existingEntries.add(product + "-" + Number(quantityType.split(';')[0]));
	});

	const store = $('#editInventory select#store').val();
	const { itemCategories } = getCategoryItemMappings();
	const categoryEntryKeys = {};

	const walkMenuItems = (nodes) => {
		if (!nodes || !nodes.length)
			return;
		nodes.forEach(node => {
			if (!node)
				return;
			if (node.entityType && node.entityType.indexOf('Category') !== -1) {
				walkMenuItems(node.activeMenuCategories || node.children || []);
				walkMenuItems(node.activeMenuItems || []);
				return;
			}
			const menuItem = getMenuItem(node.id);
			if (!menuItem || menuItem.type === 'deleted' || menuItem.recordState === 'DELETED' || !menuItem.defaultInventoryItem)
				return;
			if (!Array.isArray(menuItem.availableQuantities))
				return;

			const relevantQuantities = menuItem.availableQuantities.filter(q => q && q.inventoryItem);
			if (!relevantQuantities.length)
				return;

			relevantQuantities.forEach(quantity => {
				const entryKey = menuItem.id + '-' + Number(quantity.quantity);
				if (existingEntries.has(entryKey))
					return;
				(itemCategories[Number(menuItem.id)] || new Set()).forEach(categoryId => {
					if (!categoryEntryKeys[categoryId])
						categoryEntryKeys[categoryId] = new Set();
					categoryEntryKeys[categoryId].add(entryKey);
				});
			});
		});
	};
	walkMenuItems(getRootMenuNodes());

	const eligibleCategories = categories
		.map(category => ({
			...category,
			count: categoryEntryKeys[category.id] ? categoryEntryKeys[category.id].size : 0
		}))
		.filter(category => category.count > 0);

	if (!eligibleCategories.length) {
		messageDialog(I18n.t('local.error_message'), I18n.t('admin_local.no_entries_can_be_added_for_selected_store'));
		def.reject();
		return def.promise();
	}

	const options = eligibleCategories.map(category => '<label style="display:flex;align-items:center;gap:8px;margin-bottom:6px"><input class="inventory-category-extract" type="checkbox" value="' + category.id + '"/><span>' + category.name + ' (' + category.count + ')</span></label>').join('');
	const content = '<div style="text-align:left"><div style="max-height:320px;overflow:auto;border:1px solid #ddd;padding:8px">' + options + '</div></div>';
	const selectCategoryTitle = I18n.t('admin_local.select_a_category');
	const dialogTitle = selectCategoryTitle ? (selectCategoryTitle.charAt(0).toLocaleUpperCase() + selectCategoryTitle.slice(1)) : selectCategoryTitle;
	const readSelectedCategoryIds = () => {
		const checked = $('.inventory-category-extract:checked').toArray().map(node => Number($(node).val())).filter(id => !!id);
		selectedCategoryIds = checked;
	};

	setTimeout(() => {
		$(document).off('change.inventoryCategoryExtract').on('change.inventoryCategoryExtract', '.inventory-category-extract', readSelectedCategoryIds);
		readSelectedCategoryIds();
	}, 0);

	choiceDialog2(dialogTitle, content, [local.ok]).done(() => {
		readSelectedCategoryIds();
		const selected = selectedCategoryIds;
		$(document).off('change.inventoryCategoryExtract');
		if (!selected.length) {
			messageDialog(I18n.t('local.error_message'), I18n.t('admin_local.select_a_category'));
			def.reject();
			return;
		}
		def.resolve(selected);
	}).fail(() => {
		$(document).off('change.inventoryCategoryExtract');
		def.reject();
	});

	return def.promise();
}

export const populateAllItems = (selectedCategoryIds = [], appendToExisting = false) => {

	if (!$('#editInventory #store').select2('val')) {
		$('#editInventory #store + span').removeClass('highlight-3');
		setTimeout(() => {
			$('#editInventory #store + span').addClass('highlight-3');
		}, 100)
		return;
	}

	function compare(a, b) {
		const menuItemA = getMenuItem(a.menuItem.id)
		const menuItemB = getMenuItem(b.menuItem.id);
		const menuItemAOrder = menuItemA.globalOrder;
		const menuItemBOrder = menuItemB.globalOrder;
		return menuItemAOrder - menuItemBOrder;
	}

	ajaxCallStart("populate", 0);
	const selectedCategorySet = selectedCategoryIds.length ? getSelectedCategoryAndChildren(selectedCategoryIds) : null;
	const selectedMenuItemIds = selectedCategoryIds.length ? getSelectedMenuItemIds(selectedCategoryIds) : null;

	const existingEntries = [];
	$('#entriesFreezeTable tbody tr.selectable').each((ind, row) => {
		existingEntries.push(Number($(row).find('td#product select').select2('val')) + "-" + Number($(row).find('td#quantity select.quantity_type').select2('val').split(';')[0]));
	});

	const store = $('#editInventory select#store').val();
	get("adminService/" + localStorage.restaurantSelected + "/" + store + "/getActiveStocks").done(stocks => {
		function f(s) {
			const menuItem = getMenuItem(s.menuItem.id);
			if (!getMenuItem(s.menuItem.id) || getMenuItem(s.menuItem.id).type === "deleted") {
				return false;
			}
			if (selectedCategorySet && selectedMenuItemIds && !selectedMenuItemIds.has(Number(menuItem.id))) {
				if (!selectedCategorySet.has(Number(menuItem.menuCategoryId))) {
					return false;
				}
			}

			return menuItem.defaultInventoryItem;
		}
		const count = $('div#editInventory #entriesFreezeTable > table tbody tr.selectable').length;
		const buildInventoryCandidates = (sourceEntries) => {
			const seen = new Set();
			const candidates = [];
			const addCandidate = (item, quantity, count = 0, lastCheck = null) => {
				const key = Number(item.id) + '-' + Number(quantity);
				if (seen.has(key))
					return;
				seen.add(key);
				candidates.push({
					menuItem: { id: Number(item.id) },
					quantity: Number(quantity),
					count: Number(count || 0),
					lastCheck: lastCheck
				});
			};

			(sourceEntries || []).forEach(stock => {
				if (!stock || !stock.menuItem)
					return;
				addCandidate({ id: Number(stock.menuItem.id) }, Number(stock.quantity), Number(stock.count || 0), stock.lastCheck);
			});

			const walk = (nodes) => {
				if (!nodes || !nodes.length)
					return;
				nodes.forEach(node => {
					if (!node)
						return;
					const isCategory = node.entityType && node.entityType.indexOf('Category') !== -1;
					if (isCategory) {
						walk(node.activeMenuCategories || node.children || []);
						walk(node.activeMenuItems || []);
						return;
					}
					const menuItem = getMenuItem(node.id);
					if (!menuItem || menuItem.type === 'deleted' || menuItem.recordState === 'DELETED' || !menuItem.defaultInventoryItem)
						return;
					if (selectedCategorySet && selectedMenuItemIds && !selectedMenuItemIds.has(Number(menuItem.id))) {
						if (!selectedCategorySet.has(Number(menuItem.menuCategoryId)))
							return;
					}
					if (!Array.isArray(menuItem.availableQuantities))
						return;
					menuItem.availableQuantities.filter(q => q && q.inventoryItem).forEach(q => {
						addCandidate(menuItem, Number(q.quantity), 0, null);
					});
				});
			};

			walk(getRootMenuNodes());
			return candidates;
		};

		const applyEntries = (entries) => {
			if (appendToExisting || count == 0)
				entries.filter(f).sort(compare).forEach((stock, ind) => {
					const menuItem = getMenuItem(stock.menuItem.id);
					console.log(menuItem.id, menuItem.name, menuItem.defaultInventoryItem, stock.quantity, stock.count);
					if (menuItem.recordState === "DELETED" || !menuItem.defaultInventoryItem)
						return;
					if (!menuItem.availableQuantities.filter(q => q.inventoryItem && q.quantity === stock.quantity).length)
						return;
					var found = false;
					if (found) return;
					if (!stock.menuItem)
						return;
					if (existingEntries.indexOf(stock.menuItem.id + "-" + stock.quantity) !== -1)
						return;

					const entry = addNewEntry({
						menuItem: menuItem,
						quantity: stock.quantity,
						quantityType: menuItem.quantityType,
						originalCount: stock.count
					}, false);

					checkEntry({
						currentTarget: entry
					})
				})
			ajaxCallEnd("populate");
		};

		const allEntries = buildInventoryCandidates(stocks);
		const noTraffic = (entries) => entries.filter(stock => {
			if (!stock || !stock.menuItem)
				return false;
			const menuItem = getMenuItem(stock.menuItem.id);
			if (!menuItem || menuItem.type === 'deleted' || menuItem.recordState === 'DELETED')
				return false;
			if (selectedCategorySet && selectedMenuItemIds && !selectedMenuItemIds.has(Number(menuItem.id))) {
				if (!selectedCategorySet.has(Number(menuItem.menuCategoryId)))
					return false;
			}
			if (!menuItem.defaultInventoryItem)
				return false;
			return Number(stock.count || 0) === 0 && (!stock.lastCheck || moment(stock.lastCheck).isBefore(moment().add(-1, 'month')));
		});

		const noTrafficEntries = noTraffic(allEntries);
		if (noTrafficEntries.length > 0) {
			const list = noTrafficEntries.slice(0, 5).map(stock => {
				const menuItem = getMenuItem(stock.menuItem.id);
				return menuItem ? getLocale(menuItem.name) : (stock.menuItem && stock.menuItem.name ? getLocale(stock.menuItem.name) : I18n.t('admin_local._item'));
			}).join(', ');
			const extra = noTrafficEntries.length > 5 ? ' ' + (noTrafficEntries.length - 5) + ' more' : '';
			const message = String.format(I18n.t('admin_local.no_traffic_items_message'), list, extra);
			choiceDialog2(I18n.t('local.question'), message, [
				I18n.t('admin_local.exclude_no_traffic_items'),
				I18n.t('admin_local.keep_no_traffic_items')
			]).done(choice => {
				const filtered = allEntries.filter(stock => !noTrafficEntries.some(item => item.menuItem && item.menuItem.id === stock.menuItem.id && item.quantity === stock.quantity));
				applyEntries(choice === 0 ? filtered : allEntries);
			});
			return;
		}
		applyEntries(allEntries);
	})
}

export const extractCategoryItems = () => {
	showCategoryExtractDialog().done(selectedCategoryIds => {
		populateAllItems(selectedCategoryIds, true);
	});
}

export const setViewType = (type) => {
	if (type === 'list') {
		$('#editInventory #view-type-dropdown').removeClass('i_list');

		$('#editInventory #view-type-dropdown').addClass('i_list_35');
		$('#editInventory').removeClass('thumbs');
		$('#editInventory').addClass('list')
	} else {
		$('#editInventory #view-type-dropdown').removeClass('i_list_35');
		$('#editInventory #view-type-dropdown').addClass('i_list');
		$('#editInventory').removeClass('list');
		$('#editInventory').addClass('thumbs')
	}
	localStorage.inventoryViewType = type;
}

export const viewStock = () => {
	return hasRole("stockmanagement.viewstock");
}

export const waiterAccessOnly = () => {
	return auth.myStatus.roles.filter(role => (role.role === "Store" && role.entity === "Store")).length > 0;
}
